// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// export default function MembershipUserPage() {
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [paymentModal, setPaymentModal] = useState(null);
//   const [activeTab, setActiveTab] = useState("overview");
//   const [enrollmentData, setEnrollmentData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     background: "",
//     goals: ""
//   });
//   const [focusedField, setFocusedField] = useState(null);
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [closeHover, setCloseHover] = useState(false);
//   const [backHover, setBackHover] = useState(false);
//   const [pageCrossHover, setPageCrossHover] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [memberships, setMemberships] = useState([]);
//   const [enrollmentStatus, setEnrollmentStatus] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [enrollmentId, setEnrollmentId] = useState(null);
//   const navigate = useNavigate();

//   // API Configuration
//   const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com/lms";
//   const API_MEMBERSHIPS = `${API_BASE_URL}/membership/all/`;

//   // Fetch memberships from API
//   useEffect(() => {
//     fetchMemberships();
//   }, []);

//   const fetchMemberships = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       const token = localStorage.getItem("jwttoken") || 
//                     localStorage.getItem("jwtToken") || 
//                     localStorage.getItem("token");
      
//       console.log("Token for memberships API:", token ? "Present" : "Missing");
      
//       if (!token) {
//         throw new Error("Please login to view memberships");
//       }

//       const response = await axios.get(API_MEMBERSHIPS, {
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Content-Type": "application/json"
//         },
//         timeout: 10000
//       });

//       console.log("API Response:", response.data);

//       if (response.data && Array.isArray(response.data)) {
//         // Transform API data to match frontend structure
//         const transformedMemberships = response.data.map(membership => ({
//           id: membership.id,
//           name: membership.title || "Unnamed Membership",
//           type: membership.membership_type || "basic",
//           price: membership.access_type === "free" ? "Free" : `₹${parseFloat(membership.price).toFixed(2)}`,
//           originalPrice: membership.price,
//           access_type: membership.access_type,
//           instructor: "Vetrina Healthcare",
//           instructorBio: "Leading veterinary education provider with expert instructors",
//           description: membership.description || "Comprehensive veterinary training program",
//           shortDescription: membership.intended_learner || "For veterinary professionals and students",
//           coverImage: membership.cover_image || "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=600&q=60",
//           promoVideo: membership.promo_video_url || "",
          
//           // Use actual courses from API
//           courses: membership.courses && membership.courses.length > 0 
//             ? membership.courses.map(course => ({
//                 id: course.course_id,
//                 title: course.title || "Untitled Course",
//                 description: course.description || "",
//                 cover_img: course.cover_img,
//                 duration: "Self-paced",
//                 level: "Beginner",
//                 lessons: 0,
//                 objectives: [
//                   "Learn course fundamentals",
//                   "Understand key concepts",
//                   "Apply knowledge practically"
//                 ],
//                 resources: ["Study Materials", "Video Lessons", "Quizzes"]
//               }))
//             : [
//                 {
//                   id: 0,
//                   title: "Coming Soon",
//                   description: "Courses will be added to this membership soon.",
//                   duration: "Self-paced",
//                   level: "All Levels",
//                   lessons: 0,
//                   objectives: ["Stay tuned for course updates"],
//                   resources: ["Announcements"]
//                 }
//               ],
          
//           // Create curriculum from courses
//           curriculum: membership.courses && membership.courses.length > 0
//             ? membership.courses.map((course, index) => ({
//                 name: course.title || "Untitled Course",
//                 duration: "Self-paced",
//                 type: "core",
//                 courseId: course.course_id
//               }))
//             : [
//                 {
//                   name: "Course Content Coming Soon",
//                   duration: "Self-paced",
//                   type: "core"
//                 }
//               ],
          
//           features: [
//             { name: "Course Certificates", icon: "🎓", included: true },
//             { name: "Downloadable Resources", icon: "📥", included: true },
//             { name: "Community Access", icon: "👥", included: true },
//             { name: "Email Support", icon: "📧", included: true },
//             { name: "Live Q&A Sessions", icon: "🎥", included: membership.membership_type === "pro" || membership.membership_type === "enterprise" },
//             { name: "1-on-1 Mentoring", icon: "🎯", included: membership.membership_type === "enterprise" }
//           ],
//           rating: 4.5,
//           reviews: membership.reviews_count || 0,
//           students: membership.enrolled_students || 0,
//           accessExpiration: membership.expiry_type === "lifetime" ? "Lifetime" : 
//                            membership.expiry_months ? `${membership.expiry_months} months` : "Monthly",
//           category: membership.category || "Veterinary Education",
//           tags: membership.tags || ["veterinary", "education", "training"],
//           whatsIncluded: [
//             "Access to all course materials",
//             "Video lectures and tutorials",
//             "Downloadable resources",
//             "Certificate of completion",
//             "Community forum access"
//           ],
//           intendedLearners: membership.intended_learner ? 
//                            [membership.intended_learner] : 
//                            ["Veterinary Students", "Animal Care Professionals"],
//           status: membership.status,
//           apiData: membership // Keep original API data
//         }));
        
//         setMemberships(transformedMemberships);
        
//         // For development/testing - add mock data if API returns empty
//         if (transformedMemberships.length === 0) {
//           console.log("No memberships found, using sample data");
//           setMemberships(getSampleMemberships());
//         }
//       } else {
//         console.log("Unexpected response format, using sample data");
//         setMemberships(getSampleMemberships());
//       }
//     } catch (error) {
//       console.error("Error fetching memberships:", error);
      
//       let errorMsg = "Failed to load memberships. ";
//       if (error.response) {
//         if (error.response.status === 401) {
//           errorMsg = "Please login to view memberships";
//         } else if (error.response.status === 403) {
//           errorMsg = "You don't have permission to view memberships";
//         } else {
//           errorMsg += `Server error: ${error.response.status}`;
//         }
//       } else if (error.request) {
//         errorMsg = "Network error. Please check your connection.";
//       } else {
//         errorMsg += error.message;
//       }
      
//       setError(errorMsg);
      
//       // Use sample data for development
//       console.log("Using sample data due to API error");
//       setMemberships(getSampleMemberships());
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Sample data for development
//   const getSampleMemberships = () => [
//     {
//       id: 1,
//       name: "Basic Veterinary Membership",
//       type: "basic",
//       price: "Free",
//       instructor: "Dr. Rajesh Sharma",
//       instructorBio: "15+ years in veterinary education, specialized in clinical training",
//       description: "Perfect for beginners to start learning. Includes limited course access and community support.",
//       shortDescription: "Essential veterinary knowledge for beginners and students",
//       coverImage: "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=600&q=60",
//       promoVideo: "https://www.youtube.com/embed/J4kzKpMP6o8",
//       courses: [
//         {
//           id: 87,
//           title: "Test_1",
//           description: "testing method",
//           cover_img: "https://vetrina-kaas.s3.us-west-2.amazonaws.com/courses/covers/download_1.jpeg",
//           duration: "Self-paced",
//           level: "Beginner",
//           lessons: 0,
//           objectives: [
//             "Learn the fundamentals of nutrition",
//             "Understand diet formulation",
//             "Identify nutritional requirements",
//             "Plan balanced diets for pets"
//           ],
//           resources: ["Nutrition Charts", "Diet Plans", "Quizzes", "Case Studies"]
//         }
//       ],
//       curriculum: [
//         { name: "Test_1", duration: "Self-paced", type: "core", courseId: 87 }
//       ],
//       features: [
//         { name: "Course Certificates", icon: "🎓", included: true },
//         { name: "Downloadable Resources", icon: "📥", included: true },
//         { name: "Community Access", icon: "👥", included: true },
//         { name: "Email Support", icon: "📧", included: true },
//         { name: "Live Q&A Sessions", icon: "🎥", included: false },
//         { name: "1-on-1 Mentoring", icon: "🎯", included: false }
//       ],
//       rating: 4.5,
//       reviews: 234,
//       students: 1250,
//       accessExpiration: "Lifetime",
//       category: "Clinical Foundations",
//       tags: ["beginner", "nutrition", "fundamentals"],
//       whatsIncluded: [
//         "Lifetime access to basic courses",
//         "8+ hours of video content",
//         "12 downloadable resources",
//         "Mobile app access",
//         "Certificate of completion"
//       ],
//       intendedLearners: ["Veterinary Students", "Animal Care Assistants", "Pet Owners", "Shelter Staff"],
//       apiData: {
//         id: 1,
//         title: "Basic Veterinary Membership",
//         membership_type: "basic",
//         access_type: "free",
//         price: "0.00"
//       }
//     }
//   ];

//   // Helper function to check enrollment status
//   const checkUserEnrollment = (membershipId) => {
//     try {
//       const userEnrollments = JSON.parse(localStorage.getItem('userEnrollments') || '{}');
//       return userEnrollments[membershipId] || null;
//     } catch (error) {
//       console.error("Error checking enrollment:", error);
//       return null;
//     }
//   };

//   // Handle enrollment submission - Step 1: Submit enrollment request
//   const handleEnrollmentSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!selectedPlan) {
//       alert("Please select a membership plan first");
//       return;
//     }
    
//     setIsSubmitting(true);
    
//     try {
//       const token = localStorage.getItem("jwttoken") || 
//                     localStorage.getItem("jwtToken") || 
//                     localStorage.getItem("token");
      
//       if (!token) {
//         alert("Please login to enroll");
//         navigate("/login");
//         return;
//       }

//       // Get the ACTUAL membership ID from apiData
//       const membershipId = selectedPlan.apiData?.id;
//       const isFreeMembership = selectedPlan.access_type === "free" || selectedPlan.price === "Free";
      
//       if (!membershipId) {
//         throw new Error("Membership ID not found in API data");
//       }
      
//       // Prepare enrollment data for API
//       const enrollmentPayload = {
//         name: enrollmentData.name,
//         email: enrollmentData.email,
//         phone: enrollmentData.phone,
//         background: enrollmentData.background,
//         goals: enrollmentData.goals
//       };

//       console.log("Submitting enrollment request to:", `${API_BASE_URL}/membership/enroll/${membershipId}/`);
//       console.log("Membership ID from API:", membershipId);
//       console.log("Payload:", enrollmentPayload);

//       // Step 1: Submit enrollment request to /membership/enroll/<membership_id>/
//       const response = await axios.post(
//         `${API_BASE_URL}/membership/enroll/${membershipId}/`,
//         enrollmentPayload,
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );

//       console.log("Enrollment response:", response.data);

//       if (response.data) {
//         // Store enrollment ID for later use (for payment)
//         const enrollmentId = response.data.enrollment_id || 
//                             response.data.id || 
//                             response.data.enrollmentId;
        
//         if (!enrollmentId) {
//           console.warn("No enrollment ID in response, using mock ID for testing");
//           // For testing, create a mock enrollment ID
//           const mockEnrollmentId = `enroll_${Date.now()}_${membershipId}`;
//           setEnrollmentId(mockEnrollmentId);
          
//           // Store enrollment status locally for testing
//           const userEnrollments = JSON.parse(localStorage.getItem('userEnrollments') || '{}');
//           userEnrollments[membershipId] = {
//             status: "pending",
//             enrollmentId: mockEnrollmentId,
//             date: new Date().toISOString(),
//             membershipId: membershipId,
//             membershipName: selectedPlan.name
//           };
//           localStorage.setItem('userEnrollments', JSON.stringify(userEnrollments));
//         } else {
//           setEnrollmentId(enrollmentId);
          
//           // Store enrollment status locally
//           const userEnrollments = JSON.parse(localStorage.getItem('userEnrollments') || '{}');
//           userEnrollments[membershipId] = {
//             status: "pending",
//             enrollmentId: enrollmentId,
//             date: new Date().toISOString(),
//             membershipId: membershipId,
//             membershipName: selectedPlan.name
//           };
//           localStorage.setItem('userEnrollments', JSON.stringify(userEnrollments));
//         }
        
//         // Update enrollment status state
//         setEnrollmentStatus(prev => ({
//           ...prev,
//           [membershipId]: "pending"
//         }));
        
//         if (isFreeMembership) {
//           alert("🎉 Your enrollment request has been submitted for admin approval!");
//           setSelectedPlan(null);
//         } else {
//           alert("✅ Enrollment request submitted! Waiting for admin approval.");
//         }
        
//         // Reset form
//         setEnrollmentData({
//           name: "",
//           email: "",
//           phone: "",
//           background: "",
//           goals: ""
//         });
//       } else {
//         alert("Enrollment submission failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error submitting enrollment:", error);
      
//       let errorMsg = "Failed to submit enrollment. ";
//       if (error.response) {
//         console.error("Error response data:", error.response.data);
//         console.error("Error response status:", error.response.status);
        
//         if (error.response.status === 400) {
//           errorMsg = "Please fill all required fields correctly.";
//           if (error.response.data) {
//             const errors = Object.values(error.response.data).flat().join(', ');
//             errorMsg += ` Errors: ${errors}`;
//           }
//         } else if (error.response.status === 401) {
//           errorMsg = "Session expired. Please login again.";
//           navigate("/login");
//         } else if (error.response.status === 403) {
//           errorMsg = "You don't have permission to enroll.";
//         } else if (error.response.status === 404) {
//           errorMsg = "Membership not found. The membership ID might be incorrect.";
//         } else if (error.response.status === 409) {
//           errorMsg = "You have already enrolled in this membership.";
//         } else {
//           errorMsg += `Server error: ${error.response.status}`;
//           if (error.response.data?.detail) {
//             errorMsg += ` - ${error.response.data.detail}`;
//           }
//         }
//       } else if (error.request) {
//         errorMsg = "Network error. Please check your connection.";
//       } else {
//         errorMsg += error.message;
//       }
      
//       alert(errorMsg);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Step 2: Initiate payment after admin approval
//   const handlePaymentInitiation = async () => {
//     if (!enrollmentId) {
//       alert("No enrollment found. Please submit enrollment request first.");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("jwttoken") || 
//                     localStorage.getItem("jwtToken") || 
//                     localStorage.getItem("token");
      
//       if (!token) {
//         alert("Please login to proceed with payment");
//         navigate("/login");
//         return;
//       }

//       // Get the membership ID from the selected plan
//       const membershipId = selectedPlan.apiData?.id;
      
//       // Step 2: Create payment order with enrollment ID
//       console.log("Creating payment order for enrollment:", enrollmentId);
//       console.log("Membership ID:", membershipId);
      
//       const response = await axios.post(
//         `${API_BASE_URL}/membership/order/create/${enrollmentId}/`,
//         {
//           amount: selectedPlan.originalPrice || selectedPlan.price.replace('₹', ''),
//           currency: "INR",
//           membership_id: membershipId
//         },
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );

//       console.log("Order creation response:", response.data);

//       if (response.data && response.data.order_id) {
//         // Step 3: Initiate Razorpay payment
//         initiateRazorpayPayment(response.data.order_id, selectedPlan);
//       } else {
//         alert("Failed to create payment order. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error creating payment order:", error);
//       alert("Failed to initiate payment. Please try again.");
//     }
//   };

//   // Step 3: Razorpay payment integration
//   const initiateRazorpayPayment = (orderId, plan) => {
//     const options = {
//       key: "YOUR_RAZORPAY_KEY_ID", // Replace with your Razorpay key
//       amount: plan.originalPrice * 100, // Amount in paise
//       currency: "INR",
//       name: "VetLearn",
//       description: `Payment for ${plan.name}`,
//       order_id: orderId,
//       handler: async function(response) {
//         // Handle successful payment
//         await handlePaymentVerification(response, orderId, plan);
//       },
//       prefill: {
//         name: enrollmentData.name,
//         email: enrollmentData.email,
//         contact: enrollmentData.phone
//       },
//       theme: {
//         color: "#ff7e5f"
//       },
//       modal: {
//         ondismiss: function() {
//           alert("Payment cancelled. You can try again later.");
//         }
//       }
//     };
    
//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };

//   // Step 4: Verify payment on your backend
//   const handlePaymentVerification = async (razorpayResponse, orderId, plan) => {
//     try {
//       const token = localStorage.getItem("jwttoken") || 
//                     localStorage.getItem("jwtToken") || 
//                     localStorage.getItem("token");
      
//       const verificationResponse = await axios.post(
//         `${API_BASE_URL}/payment/verify/`,
//         {
//           razorpay_payment_id: razorpayResponse.razorpay_payment_id,
//           razorpay_order_id: razorpayResponse.razorpay_order_id,
//           razorpay_signature: razorpayResponse.razorpay_signature,
//           enrollment_id: enrollmentId,
//           order_id: orderId
//         },
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );

//       if (verificationResponse.data && verificationResponse.data.success) {
//         // Update enrollment status to "active"
//         const membershipId = plan.apiData?.id;
//         const userEnrollments = JSON.parse(localStorage.getItem('userEnrollments') || '{}');
//         userEnrollments[membershipId] = {
//           status: "active",
//           enrollmentId: enrollmentId,
//           paymentId: razorpayResponse.razorpay_payment_id,
//           date: new Date().toISOString(),
//           membershipId: membershipId,
//           membershipName: plan.name
//         };
//         localStorage.setItem('userEnrollments', JSON.stringify(userEnrollments));
        
//         setEnrollmentStatus(prev => ({
//           ...prev,
//           [membershipId]: "active"
//         }));
        
//         alert(`✅ Payment successful! You are now enrolled in ${plan.name}.`);
//         setPaymentModal(null);
//         setSelectedPlan(null);
        
//         // Refresh memberships to update enrolled count
//         fetchMemberships();
//       } else {
//         alert("Payment verification failed. Please contact support.");
//       }
//     } catch (error) {
//       console.error("Error verifying payment:", error);
//       alert("Payment verification failed. Please contact support.");
//     }
//   };

//   // Handle going back to previous page
//   const handleGoBack = () => {
//     navigate(-1);
//   };

//   // Render star ratings
//   const renderStars = (rating) => {
//     const stars = [];
//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 !== 0;

//     for (let i = 0; i < 5; i++) {
//       if (i < fullStars) {
//         stars.push(<span key={i} style={{ color: "#fbbf24" }}>★</span>);
//       } else if (i === fullStars && hasHalfStar) {
//         stars.push(<span key={i} style={{ color: "#fbbf24" }}>☆</span>);
//       } else {
//         stars.push(<span key={i} style={{ color: "#e2e8f0" }}>★</span>);
//       }
//     }
//     return stars;
//   };

//   // Consolidated Styling
//   const styles = {
//     // Page Styles
//     page: {
//       minHeight: "100vh",
//       background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
//       padding: "40px 20px 40px",
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//       position: "relative",
//     },

//     // Page Header with Cross Button
//     pageHeader: {
//       position: "absolute",
//       top: "20px",
//       right: "20px",
//       zIndex: 100,
//     },

//     // Cross Button for Main Page
//     pageCrossButton: {
//       width: "50px",
//       height: "50px",
//       borderRadius: "50%",
//       background: "rgba(255, 255, 255, 0.9)",
//       border: "0px solid #e2e8f0",
//       color: "#64748b",
//       fontSize: "1.5rem",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//     },
//     pageCrossButtonHover: {
//       background: "#ef4444",
//       color: "#fff",
//       borderColor: "#ef4444",
//       transform: "rotate(90deg) scale(1.1)",
//       boxShadow: "0 6px 20px rgba(239, 68, 68, 0.3)",
//     },

//     title: {
//       textAlign: "center",
//       fontSize: "3rem",
//       fontWeight: "800",
//       background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//       WebkitBackgroundClip: "text",
//       backgroundClip: "text",
//       color: "transparent",
//       marginBottom: "10px",
//     },
//     subtitle: {
//       textAlign: "center",
//       color: "#64748b",
//       marginBottom: "10px",
//       fontSize: "1.1rem",
//       maxWidth: "600px",
//       margin: "0 auto",
//       lineHeight: "1.6",
//     },

//     // Loading and Error States
//     loadingContainer: {
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       minHeight: "50vh",
//       gap: "20px",
//     },
//     loader: {
//       width: "50px",
//       height: "50px",
//       border: "5px solid #e2e8f0",
//       borderTopColor: "#8e44ad",
//       borderRadius: "50%",
//       animation: "spin 1s linear infinite",
//     },
//     errorContainer: {
//       background: "#fee2e2",
//       border: "1px solid #fecaca",
//       borderRadius: "10px",
//       padding: "20px",
//       maxWidth: "600px",
//       margin: "30px auto",
//       textAlign: "center",
//     },
//     errorText: {
//       color: "#dc2626",
//       marginBottom: "15px",
//     },
//     retryButton: {
//       background: "#8e44ad",
//       color: "white",
//       border: "none",
//       padding: "10px 20px",
//       borderRadius: "5px",
//       cursor: "pointer",
//       fontSize: "0.9rem",
//       fontWeight: "600",
//       transition: "all 0.2s ease",
//     },

//     // Card Grid
//     cardGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//       gap: "30px",
//       maxWidth: "1200px",
//       margin: "0 auto 60px",
//     },

//     // Card Styles
//     card: {
//       background: "rgba(255, 255, 255, 0.95)",
//       borderRadius: "20px",
//       padding: "25px",
//       boxShadow: "0 8px 30px rgba(0, 0, 0, 0.05)",
//       transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//       cursor: "pointer",
//       border: "0px solid transparent",
//       display: "flex",
//       flexDirection: "column",
//       height: "100%",
//     },

//     cardHover: {
//       transform: "translateY(10px)",
//       boxShadow: "0 20px 40px rgba(37, 99, 235, 0.15)",
//       border: "2px solid #8e44ad",
//     },

//     // Card Elements
//     image: {
//       width: "100%",
//       height: "180px",
//       objectFit: "cover",
//       borderRadius: "15px",
//       marginBottom: "20px",
//     },
//     planName: {
//       fontSize: "1.5rem",
//       fontWeight: "700",
//       background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//       WebkitBackgroundClip: "text",
//       backgroundClip: "text",
//       color: "transparent",
//       marginBottom: "8px",
//     },
//     price: {
//       fontWeight: "700",
//       fontSize: "1.4rem",
//       color: "#ff7e5f",
//       marginBottom: "5px",
//     },
//     instructor: {
//       color: "#64748b",
//       fontSize: "0.9rem",
//       marginBottom: "15px",
//       display: "flex",
//       alignItems: "center",
//       gap: "5px",
//     },
//     desc: {
//       color: "#475569",
//       margin: "15px 0 20px",
//       lineHeight: "1.6",
//       flex: "1",
//       fontSize: "0.95rem",
//     },

//     // Badge Styles
//     badge: {
//       display: "inline-block",
//       padding: "6px 12px",
//       borderRadius: "20px",
//       fontSize: "0.75rem",
//       fontWeight: "600",
//       marginRight: "8px",
//       marginBottom: "10px",
//     },

//     // Button Styles
//     btn: {
//       padding: "14px 20px",
//       background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//       color: "#fff",
//       fontWeight: "600",
//       border: "none",
//       borderRadius: "12px",
//       cursor: "pointer",
//       fontSize: "1rem",
//       transition: "all 0.3s ease",
//       marginTop: "15px",
//     },
//     backBtn: {
//       padding: "10px 20px",
//       background: "transparent",
//       color: "#64748b",
//       fontWeight: "600",
//       border: "2px solid #e2e8f0",
//       borderRadius: "10px",
//       cursor: "pointer",
//       fontSize: "0.95rem",
//       transition: "all 0.2s ease",
//       display: "inline-flex",
//       alignItems: "center",
//       gap: "8px",
//     },
//     btnHover: {
//       background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//       transform: "translateY(-2px)",
//       boxShadow: "0 8px 20px rgba(136, 4, 212, 0.3)",
//     },
//     backBtnHover: {
//       background: "#f1f5f9",
//       borderColor: "#cbd5e1",
//       transform: "translateX(-3px)",
//     },

//     // Modal Backdrop
//     modalBackdrop: {
//       position: "fixed",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: "rgba(0, 0, 0, 0.7)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       zIndex: 10000,
//       padding: "20px",
//       backdropFilter: "blur(4px)",
//     },

//     // Modal Container
//     modal: {
//       background: "#fff",
//       borderRadius: "24px",
//       width: "100%",
//       maxWidth: "900px",
//       maxHeight: "90vh",
//       overflow: "hidden",
//       boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
//       display: "flex",
//       flexDirection: "column",
//     },

//     // Modal Header
//     modalHeader: {
//       padding: "25px 30px 20px",
//       borderBottom: "1px solid #e2e8f0",
//       position: "relative",
//       background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
//     },

//     // Modal Close Button
//     modalClose: {
//       position: "absolute",
//       right: "2px",
//       top: "2px",
//       width: "30px",
//       height: "30px",
//       borderRadius: "50%",
//       background: "rgba(255, 255, 255, 0.9)",
//       border: "0px solid #e2e8f0",
//       color: "#64748b",
//       fontSize: "1.2rem",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.2s ease",
//       zIndex: 10,
//     },
//     modalCloseHover: {
//       background: "#ef4444",
//       color: "#fff",
//       borderColor: "#ef4444",
//       transform: "rotate(90deg)",
//     },

//     // Modal Body
//     modalBody: {
//       padding: "30px",
//       overflowY: "auto",
//       flex: "1",
//     },

//     // Tab Styles
//     tabsContainer: {
//       display: "flex",
//       borderBottom: "2px solid #e2e8f0",
//       marginBottom: "30px",
//       gap: "10px",
//     },
//     tab: {
//       padding: "12px 24px",
//       background: "none",
//       border: "none",
//       fontSize: "0.95rem",
//       fontWeight: "600",
//       color: "#64748b",
//       cursor: "pointer",
//       position: "relative",
//       transition: "all 0.2s ease",
//     },
//     tabActive: {
//       color: "#8e44ad",
//     },
//     tabIndicator: {
//       position: "absolute",
//       bottom: "-2px",
//       left: 0,
//       right: 0,
//       height: "2px",
//       background: "#8e44ad",
//     },

//     // Section Titles
//     sectionTitle: {
//       fontSize: "1.3rem",
//       fontWeight: "700",
//       color: "#1e293b",
//       margin: "25px 0 15px",
//       paddingBottom: "10px",
//       borderBottom: "2px solid #f1f5f9",
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     },

//     // Feature Grid
//     featureGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//       gap: "15px",
//       margin: "20px 0",
//     },
//     featureItem: {
//       padding: "15px",
//       background: "#f8fafc",
//       borderRadius: "12px",
//       border: "1px solid #e2e8f0",
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//     },

//     // Course Card
//     courseCard: {
//       background: "#f8fafc",
//       borderRadius: "12px",
//       padding: "20px",
//       marginBottom: "20px",
//       borderLeft: "4px solid #ff7e5f",
//     },

//     // Form Styles
//     formGroup: {
//       marginBottom: "20px",
//     },
//     formLabel: {
//       display: "block",
//       marginBottom: "8px",
//       fontWeight: "600",
//       color: "#1e293b",
//     },
//     formInput: {
//       width: "100%",
//       display: "block",
//       padding: "12px 16px",
//       border: "1.5px solid #e2e8f0",
//       borderRadius: "10px",
//       fontSize: "1rem",
//       transition: "all 0.2s ease",
//       boxSizing: "border-box",
//       outline: "none",
//       background: "#fff"
//     },
//     formInputFocus: {
//       borderColor: "#8e44ad",
//       boxShadow: "0 0 0 3px rgba(142, 68, 173, 0.2)",
//       background: "#fff",
//     },

//     // Stats Container
//     statsContainer: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
//       gap: "20px",
//       margin: "25px 0",
//       padding: "20px",
//       background: "#f8fafc",
//       borderRadius: "15px",
//     },
//     statItem: {
//       textAlign: "center",
//     },
//     statValue: {
//       fontSize: "1.8rem",
//       fontWeight: "700",
//       color: "#ff7e5f",
//       marginBottom: "5px",
//     },
//     statLabel: {
//       fontSize: "0.9rem",
//       color: "#64748b",
//     },

//     // Payment Summary
//     paymentSummary: {
//       background: "#f8fafc",
//       borderRadius: "15px",
//       padding: "25px",
//       margin: "25px 0",
//       border: "1px solid #e2e8f0",
//     },

//     // Navigation Back Button in Modal
//     modalBackButton: {
//       position: "absolute",
//       left: "25px",
//       top: "25px",
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       background: "rgba(255, 255, 255, 0.9)",
//       border: "1px solid #e2e8f0",
//       borderRadius: "10px",
//       padding: "8px 16px",
//       color: "#64748b",
//       fontWeight: "600",
//       cursor: "pointer",
//       transition: "all 0.2s ease",
//       zIndex: 10,
//     },
//     modalBackButtonHover: {
//       background: "#f1f5f9",
//       borderColor: "#cbd5e1",
//       transform: "translateX(-3px)",
//     },

//     // Status Badge
//     statusBadge: (status) => ({
//       display: "inline-block",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.7rem",
//       fontWeight: "600",
//       marginLeft: "8px",
//       background: status === "published" ? "#10b98120" : "#fbbf2420",
//       color: status === "published" ? "#10b981" : "#f59e0b",
//     }),

//     // Enrollment Status Badge
//     enrollmentStatusBadge: (status) => ({
//       display: "inline-block",
//       padding: "4px 12px",
//       borderRadius: "20px",
//       fontSize: "0.75rem",
//       fontWeight: "600",
//       marginLeft: "10px",
//       background: status === "pending" ? "#fef3c7" : 
//                 status === "approved" ? "#d1fae5" :
//                 status === "active" ? "#dbeafe" :
//                 status === "rejected" ? "#fee2e2" : "#f1f5f9",
//       color: status === "pending" ? "#d97706" :
//              status === "approved" ? "#059669" :
//              status === "active" ? "#2563eb" :
//              status === "rejected" ? "#dc2626" : "#64748b",
//     }),
//   };

//   // Add CSS for loader animation
//   const cssStyles = `
//     @keyframes spin {
//       0% { transform: rotate(0deg); }
//       100% { transform: rotate(360deg); }
//     }
//   `;

//   // Function to render enrollment form
//   const renderEnrollmentForm = () => {
//     const isFreeMembership = selectedPlan.access_type === "free" || selectedPlan.price === "Free";
    
//     return (
//       <>
//         <h3 style={styles.sectionTitle}>📝 Enrollment Application</h3>
//         <p style={{ color: "#64748b", marginBottom: "25px" }}>
//           Complete the form below to apply for enrollment. {isFreeMembership
//             ? "Free memberships require admin approval."
//             : "Payment will be required after admin approval."}
//         </p>

//         <form onSubmit={handleEnrollmentSubmit}>
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
//             <div style={styles.formGroup}>
//               <label style={styles.formLabel}>Full Name *</label>
//               <input
//                 type="text"
//                 required
//                 style={
//                   focusedField === "name"
//                     ? { ...styles.formInput, ...styles.formInputFocus }
//                     : styles.formInput
//                 }
//                 onFocus={() => setFocusedField("name")}
//                 onBlur={() => setFocusedField(null)}
//                 value={enrollmentData.name}
//                 onChange={(e) => setEnrollmentData({ ...enrollmentData, name: e.target.value })}
//                 placeholder="Enter your full name"
//               />
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.formLabel}>Email Address *</label>
//               <input
//                 type="email"
//                 required
//                 style={
//                   focusedField === "email"
//                     ? { ...styles.formInput, ...styles.formInputFocus }
//                     : styles.formInput
//                 }
//                 onFocus={() => setFocusedField("email")}
//                 onBlur={() => setFocusedField(null)}
//                 value={enrollmentData.email}
//                 onChange={(e) => setEnrollmentData({ ...enrollmentData, email: e.target.value })}
//                 placeholder="Enter your email"
//               />
//             </div>
//           </div>

//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
//             <div style={styles.formGroup}>
//               <label style={styles.formLabel}>Phone Number *</label>
//               <input
//                 type="tel"
//                 required
//                 style={
//                   focusedField === "tel"
//                     ? { ...styles.formInput, ...styles.formInputFocus }
//                     : styles.formInput
//                 }
//                 onFocus={() => setFocusedField("tel")}
//                 onBlur={() => setFocusedField(null)}
//                 value={enrollmentData.phone}
//                 onChange={(e) => setEnrollmentData({ ...enrollmentData, phone: e.target.value })}
//                 placeholder="Enter your phone number"
//               />
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.formLabel}>Current Position</label>
//               <input
//                 type="text"
//                 style={
//                   focusedField === "position"
//                     ? { ...styles.formInput, ...styles.formInputFocus }
//                     : styles.formInput
//                 }
//                 onFocus={() => setFocusedField("position")}
//                 onBlur={() => setFocusedField(null)}
//                 placeholder="e.g., Veterinary Assistant, Student, etc."
//               />
//             </div>
//           </div>

//           <div style={styles.formGroup}>
//             <label style={styles.formLabel}>Professional Background *</label>
//             <textarea
//               required
//               rows="3"
//               style={
//                 focusedField === "professionalBackground"
//                   ? { ...styles.formInput, ...styles.formInputFocus }
//                   : styles.formInput
//               }
//               onFocus={() => setFocusedField("professionalBackground")}
//               onBlur={() => setFocusedField(null)}
//               value={enrollmentData.background}
//               onChange={(e) => setEnrollmentData({ ...enrollmentData, background: e.target.value })}
//               placeholder="Tell us about your veterinary background, education, and experience..."
//             />
//           </div>

//           <div style={styles.formGroup}>
//             <label style={styles.formLabel}>Learning Objectives & Career Goals *</label>
//             <textarea
//               required
//               rows="3"
//               style={
//                 focusedField === "goals"
//                   ? { ...styles.formInput, ...styles.formInputFocus }
//                   : styles.formInput
//               }
//               onFocus={() => setFocusedField("goals")}
//               onBlur={() => setFocusedField(null)}
//               value={enrollmentData.goals}
//               onChange={(e) => setEnrollmentData({ ...enrollmentData, goals: e.target.value })}
//               placeholder="What specific skills do you want to develop? How will this membership help your career?"
//             />
//           </div>

//           {/* Membership Summary */}
//           <div style={styles.paymentSummary}>
//             <h4 style={{ marginBottom: "15px", color: "#1e293b" }}>📋 Membership Summary</h4>
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
//               <div>
//                 <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Plan Type</div>
//                 <div style={{ fontWeight: "600", color: "#1e293b" }}>{selectedPlan.name}</div>
//               </div>
//               <div>
//                 <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Price</div>
//                 <div style={{ fontWeight: "600", color: "#ff7e5f" }}>{selectedPlan.price}</div>
//               </div>
//               <div>
//                 <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Access Duration</div>
//                 <div style={{ fontWeight: "600", color: "#1e293b" }}>{selectedPlan.accessExpiration}</div>
//               </div>
//               <div>
//                 <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Courses Included</div>
//                 <div style={{ fontWeight: "600", color: "#1e293b" }}>{selectedPlan.courses.length}</div>
//               </div>
//             </div>
//           </div>

//           <div style={{ textAlign: "center", marginTop: "30px" }}>
//             <button
//               type="submit"
//               style={{
//                 ...styles.btn,
//                 padding: "16px 40px",
//                 fontSize: "1.1rem",
//                 background: isFreeMembership
//                   ? "linear-gradient(90deg, #10b981, #34d399)"
//                   : "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//                 opacity: isSubmitting ? 0.7 : 1,
//                 cursor: isSubmitting ? "not-allowed" : "pointer",
//               }}
//               onMouseEnter={(e) => {
//                 if (!isSubmitting) {
//                   e.target.style.transform = "translateY(-2px)";
//                   e.target.style.boxShadow = isFreeMembership
//                     ? "0 8px 20px rgba(16, 185, 129, 0.3)"
//                     : "0 8px 20px rgba(37, 99, 235, 0.3)";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (!isSubmitting) {
//                   e.target.style.transform = "translateY(0)";
//                   e.target.style.boxShadow = "none";
//                 }
//               }}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? (
//                 <>⏳ Submitting...</>
//               ) : isFreeMembership ? (
//                 <>🚀 Submit Free Enrollment Request</>
//               ) : (
//                 <>📝 Submit Enrollment Request</>
//               )}
//             </button>
//             <p style={{ color: "#94a3b8", fontSize: "0.9rem", marginTop: "15px" }}>
//               <span style={{ color: "#10b981" }}>✓</span> Your information is secure and encrypted
//             </p>
//           </div>
//         </form>
//       </>
//     );
//   };

//   return (
//     <div style={styles.page}>
//       <style>{cssStyles}</style>
      
//       {/* Cross Button on Main Page */}
//       <div style={styles.pageHeader}>
//         <button
//           style={{
//             ...styles.pageCrossButton,
//             ...(pageCrossHover ? styles.pageCrossButtonHover : {}),
//           }}
//           onClick={handleGoBack}
//           onMouseEnter={() => setPageCrossHover(true)}
//           onMouseLeave={() => setPageCrossHover(false)}
//           title="Close Membership Page"
//         >
//           ✕
//         </button>
//       </div>

//       <h1 style={styles.title}>VetLearn Membership Plans</h1>
//       <p style={styles.subtitle}>
//         Choose from our expertly crafted membership tiers designed to match your veterinary career goals.
//         Transform your skills with structured learning paths and expert mentorship.
//       </p>

//       {/* Loading State */}
//       {loading && (
//         <div style={styles.loadingContainer}>
//           <div style={styles.loader}></div>
//           <p style={{ color: "#64748b" }}>Loading memberships...</p>
//         </div>
//       )}

//       {/* Error State */}
//       {error && !loading && (
//         <div style={styles.errorContainer}>
//           <p style={styles.errorText}>{error}</p>
//           <button 
//             style={styles.retryButton}
//             onClick={fetchMemberships}
//             onMouseEnter={(e) => e.target.style.opacity = "0.8"}
//             onMouseLeave={(e) => e.target.style.opacity = "1"}
//           >
//             Retry Loading
//           </button>
//         </div>
//       )}

//       {/* Membership Cards Grid */}
//       {!loading && !error && memberships.length > 0 && (
//         <div style={styles.cardGrid}>
//           {memberships.map((plan) => {
//             // Get the ACTUAL API membership ID
//             const apiMembershipId = plan.apiData?.id;
            
//             return (
//               <div
//                 key={plan.id}
//                 style={{
//                   ...styles.card,
//                   ...(hoveredCard === plan.id ? styles.cardHover : {}),
//                 }}
//                 onMouseEnter={() => setHoveredCard(plan.id)}
//                 onMouseLeave={() => setHoveredCard(null)}
//               >
//                 <img src={plan.coverImage} alt={plan.name} style={styles.image} />
//                 <div style={styles.planName}>
//                   {plan.name}
//                   <span style={styles.statusBadge(plan.status)}>
//                     {plan.status || "active"}
//                   </span>
//                 </div>
//                 <div style={styles.price}>{plan.price}</div>
//                 <div style={styles.instructor}>
//                   <span style={{ color: "#ff7e5f" }}>👨‍🏫</span>
//                   Instructor: <strong>{plan.instructor}</strong>
//                 </div>
//                 <p style={styles.desc}>{plan.description}</p>

//                 <div style={{ marginTop: "auto" }}>
//                   <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
//                     {renderStars(plan.rating)}
//                     <span style={{ marginLeft: "8px", color: "#64748b", fontSize: "0.9rem" }}>
//                       ({plan.rating}) • {plan.students} students
//                     </span>
//                   </div>

//                   <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "15px" }}>
//                     {plan.tags.slice(0, 3).map((tag, idx) => (
//                       <span
//                         key={idx}
//                         style={{
//                           ...styles.badge,
//                           background: idx === 0 ? "#dbeafe" : "#f1f5f9",
//                           color: idx === 0 ? "#ff7e5f" : "#695b47ff",
//                         }}
//                       >
//                         #{tag}
//                       </span>
//                     ))}
//                   </div>
//                 </div>

//                 {/* VIEW DETAILS BUTTON - SIMPLE VERSION */}
//                 <button
//                   style={{ 
//                     ...styles.btn, 
//                     width: "100%",
//                     background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = "translateY(-2px)";
//                     e.target.style.boxShadow = "0 8px 20px rgba(83, 6, 146, 0.22)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = "translateY(0)";
//                     e.target.style.boxShadow = "none";
//                   }}
//                   onClick={() => {
//                     setSelectedPlan(plan);
//                     setActiveTab("overview");
//                   }}
//                 >
//                   View Details & Enroll
//                 </button>
                
//                 {/* ADD ENROLLMENT STATUS INDICATOR BELOW THE BUTTON */}
//                 {apiMembershipId && (() => {
//                   const enrollment = checkUserEnrollment(apiMembershipId);
                  
//                   if (enrollment) {
//                     let statusText = "";
//                     let statusColor = "";
                    
//                     switch(enrollment.status) {
//                       case "pending":
//                         statusText = "⏳ Waiting for approval";
//                         statusColor = "#f59e0b";
//                         break;
//                       case "approved":
//                         statusText = "✅ Approved - Pay now";
//                         statusColor = "#10b981";
//                         break;
//                       case "active":
//                         statusText = "✅ Already Enrolled";
//                         statusColor = "#3b82f6";
//                         break;
//                       case "rejected":
//                         statusText = "❌ Enrollment rejected";
//                         statusColor = "#ef4444";
//                         break;
//                     }
                    
//                     return (
//                       <div style={{ textAlign: "center", marginTop: "10px" }}>
//                         <span style={{
//                           display: "inline-block",
//                           padding: "4px 12px",
//                           borderRadius: "20px",
//                           fontSize: "0.75rem",
//                           fontWeight: "600",
//                           backgroundColor: `${statusColor}20`,
//                           color: statusColor,
//                         }}>
//                           {statusText}
//                         </span>
//                         <p style={{ fontSize: "0.7rem", color: "#94a3b8", marginTop: "4px" }}>
//                           Membership ID: {apiMembershipId}
//                         </p>
//                       </div>
//                     );
//                   }
//                   return null;
//                 })()}
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* No Memberships State */}
//       {!loading && !error && memberships.length === 0 && (
//         <div style={{ textAlign: "center", padding: "50px", color: "#64748b" }}>
//           <h3>No membership plans available at the moment.</h3>
//           <p>Please check back later or contact support.</p>
//         </div>
//       )}

//       {/* Plan Details Modal */}
//       {selectedPlan && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modal}>
//             {/* Modal Header */}
//             <div style={styles.modalHeader}>
//               <button
//                 style={{
//                   ...styles.modalClose,
//                   ...(closeHover ? styles.modalCloseHover : {}),
//                 }}
//                 onClick={() => setSelectedPlan(null)}
//                 onMouseEnter={() => setCloseHover(true)}
//                 onMouseLeave={() => setCloseHover(false)}
//               >
//                 ✕
//               </button>

//               <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
//                 <div>
//                   <h2 style={styles.planName}>{selectedPlan.name}</h2>
//                   <div style={{ display: "flex", alignItems: "center", gap: "15px", marginTop: "10px" }}>
//                     <span style={styles.price}>{selectedPlan.price}</span>
//                     <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
//                       <strong>Access:</strong> {selectedPlan.accessExpiration}
//                     </span>
//                     <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
//                       <strong>Category:</strong> {selectedPlan.category}
//                     </span>
//                     <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
//                       <strong>ID:</strong> {selectedPlan.apiData?.id}
//                     </span>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   {renderStars(selectedPlan.rating)}
//                   <span style={{ marginLeft: "8px", color: "#64748b" }}>
//                     {selectedPlan.rating} ({selectedPlan.reviews} reviews)
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Modal Body */}
//             <div style={styles.modalBody}>
//               {/* Tabs Navigation */}
//               <div style={styles.tabsContainer}>
//                 {["overview", "curriculum", "instructor", "enroll"].map((tab) => (
//                   <button
//                     key={tab}
//                     style={{
//                       ...styles.tab,
//                       ...(activeTab === tab ? styles.tabActive : {}),
//                     }}
//                     onClick={() => setActiveTab(tab)}
//                   >
//                     {tab.charAt(0).toUpperCase() + tab.slice(1)}
//                     {activeTab === tab && <span style={styles.tabIndicator} />}
//                   </button>
//                 ))}
//               </div>

//               {/* Overview Tab */}
//               {activeTab === "overview" && (
//                 <div>
//                   <p style={{ color: "#475569", lineHeight: "1.8", marginBottom: "25px" }}>
//                     {selectedPlan.description}
//                   </p>

//                   {/* Stats */}
//                   <div style={styles.statsContainer}>
//                     <div style={styles.statItem}>
//                       <div style={styles.statValue}>{selectedPlan.students}+</div>
//                       <div style={styles.statLabel}>Students Enrolled</div>
//                     </div>
//                     <div style={styles.statItem}>
//                       <div style={styles.statValue}>{selectedPlan.courses.length}</div>
//                       <div style={styles.statLabel}>Courses Included</div>
//                     </div>
//                     <div style={styles.statItem}>
//                       <div style={styles.statValue}>{selectedPlan.accessExpiration}</div>
//                       <div style={styles.statLabel}>Access Duration</div>
//                     </div>
//                     <div style={styles.statItem}>
//                       <div style={styles.statValue}>{selectedPlan.rating}/5</div>
//                       <div style={styles.statLabel}>Average Rating</div>
//                     </div>
//                   </div>

//                   {/* What's Included */}
//                   <div>
//                     <h3 style={styles.sectionTitle}>🎁 What's Included</h3>
//                     <div style={styles.featureGrid}>
//                       {selectedPlan.whatsIncluded.map((item, idx) => (
//                         <div key={idx} style={styles.featureItem}>
//                           <span style={{ fontSize: "1.2rem" }}>✓</span>
//                           <span style={{ color: "#1e293b" }}>{item}</span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Features */}
//                   <div>
//                     <h3 style={styles.sectionTitle}>✨ Features & Benefits</h3>
//                     <div style={styles.featureGrid}>
//                       {selectedPlan.features.map((feature, idx) => (
//                         <div key={idx} style={styles.featureItem}>
//                           <span style={{ fontSize: "1.2rem" }}>{feature.icon}</span>
//                           <div>
//                             <div style={{ fontWeight: "600", color: "#1e293b" }}>{feature.name}</div>
//                             <div style={{
//                               fontSize: "0.85rem",
//                               color: feature.included ? "#10b981" : "#94a3b8"
//                             }}>
//                               {feature.included ? "✓ Included" : "✗ Not included"}
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Intended Learners */}
//                   <div>
//                     <h3 style={styles.sectionTitle}>🎯 Intended For</h3>
//                     <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
//                       {selectedPlan.intendedLearners.map((learner, idx) => (
//                         <span
//                           key={idx}
//                           style={{
//                             ...styles.badge,
//                             background: "#ebd5b3ff",
//                             color: "#ff7e5f",
//                             border: "1px solid #bae6fd",
//                           }}
//                         >
//                           {learner}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Curriculum Tab */}
//               {activeTab === "curriculum" && (
//                 <div>
//                   <h3 style={styles.sectionTitle}>📚 Course Curriculum</h3>
                  
//                   {selectedPlan.courses.length > 0 ? (
//                     <>
//                       {/* Display each course from the API */}
//                       {selectedPlan.courses.map((course, idx) => (
//                         <div
//                           key={course.id || idx}
//                           style={{
//                             ...styles.courseCard,
//                             borderLeftColor: "#ff7e5f",
//                           }}
//                         >
//                           <div style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
//                             {course.cover_img && (
//                               <img 
//                                 src={course.cover_img} 
//                                 alt={course.title}
//                                 style={{
//                                   width: "120px",
//                                   height: "80px",
//                                   objectFit: "cover",
//                                   borderRadius: "8px",
//                                   flexShrink: 0
//                                 }}
//                               />
//                             )}
//                             <div style={{ flex: 1 }}>
//                               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//                                 <div>
//                                   <h4 style={{ fontWeight: "600", color: "#1e293b", marginBottom: "5px" }}>
//                                     {course.title}
//                                   </h4>
//                                   <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "10px" }}>
//                                     <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
//                                       ⏱️ {course.duration || "Self-paced"}
//                                     </span>
//                                     <span style={{
//                                       ...styles.badge,
//                                       background: "#dbeafe",
//                                       color: "#ff7e5f",
//                                       fontSize: "0.75rem",
//                                       padding: "4px 8px",
//                                     }}>
//                                       {course.level || "All Levels"}
//                                     </span>
//                                   </div>
//                                 </div>
//                                 <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
//                                   Course {idx + 1}
//                                 </span>
//                               </div>

//                               {course.description && (
//                                 <p style={{ color: "#64748b", marginBottom: "15px", fontSize: "0.95rem" }}>
//                                   {course.description}
//                                 </p>
//                               )}

//                               {/* Learning Objectives */}
//                               {course.objectives && course.objectives.length > 0 && (
//                                 <div style={{ marginBottom: "15px" }}>
//                                   <strong style={{ color: "#475569", display: "block", marginBottom: "8px" }}>
//                                     Learning Objectives:
//                                   </strong>
//                                   <ul style={{ margin: 0, paddingLeft: "20px", color: "#64748b" }}>
//                                     {course.objectives.map((obj, objIdx) => (
//                                       <li key={objIdx} style={{ marginBottom: "4px" }}>{obj}</li>
//                                     ))}
//                                   </ul>
//                                 </div>
//                               )}

//                               {/* Resources */}
//                               {course.resources && course.resources.length > 0 && (
//                                 <div>
//                                   <strong style={{ color: "#475569", display: "block", marginBottom: "8px" }}>
//                                     Resources Included:
//                                   </strong>
//                                   <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
//                                     {course.resources.map((resource, resIdx) => (
//                                       <span
//                                         key={resIdx}
//                                         style={{
//                                           ...styles.badge,
//                                           background: "#f1f5f9",
//                                           color: "#475569",
//                                           border: "1px solid #e2e8f0",
//                                         }}
//                                       >
//                                         {resource}
//                                       </span>
//                                     ))}
//                                   </div>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </>
//                   ) : (
//                     <div style={{ 
//                       textAlign: "center", 
//                       padding: "40px", 
//                       background: "#f8fafc", 
//                       borderRadius: "12px",
//                       color: "#64748b"
//                     }}>
//                       <p style={{ fontSize: "1.1rem", marginBottom: "10px" }}>
//                         📚 No courses available yet
//                       </p>
//                       <p>Courses will be added to this membership soon.</p>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Instructor Tab */}
//               {activeTab === "instructor" && (
//                 <div>
//                   <div style={{ display: "flex", gap: "25px", marginBottom: "30px" }}>
//                     <div style={{
//                       width: "120px",
//                       height: "120px",
//                       borderRadius: "50%",
//                       background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       color: "white",
//                       fontSize: "2.5rem",
//                       fontWeight: "700",
//                       flexShrink: 0,
//                     }}>
//                       {selectedPlan.instructor.split(' ').map(n => n[0]).join('')}
//                     </div>
//                     <div>
//                       <h3 style={{ fontSize: "1.5rem", fontWeight: "700", color: "#1e293b", marginBottom: "10px" }}>
//                         {selectedPlan.instructor}
//                       </h3>
//                       <p style={{ color: "#475569", lineHeight: "1.6", marginBottom: "20px" }}>
//                         {selectedPlan.instructorBio}
//                       </p>
//                       <div style={{ display: "flex", gap: "25px" }}>
//                         <div>
//                           <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "#ff7e5f" }}>
//                             {selectedPlan.rating}/5
//                           </div>
//                           <div style={{ fontSize: "0.9rem", color: "#64748b" }}>Instructor Rating</div>
//                         </div>
//                         <div>
//                           <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "#8e44ad" }}>
//                             {selectedPlan.students}+
//                           </div>
//                           <div style={{ fontSize: "0.9rem", color: "#64748b" }}>Students Taught</div>
//                         </div>
//                         <div>
//                           <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "#ff7e5f" }}>
//                             {selectedPlan.courses.length}
//                           </div>
//                           <div style={{ fontSize: "0.9rem", color: "#64748b" }}>Courses Created</div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div>
//                     <h3 style={styles.sectionTitle}>📝 Teaching Philosophy</h3>
//                     <p style={{ color: "#475569", lineHeight: "1.8" }}>
//                       With extensive experience in veterinary education and clinical practice,
//                       {selectedPlan.instructor.split(' ')[0]} brings real-world expertise and practical
//                       knowledge to every course. Committed to advancing veterinary education through
//                       innovative teaching methods and hands-on learning experiences.
//                     </p>
//                   </div>
//                 </div>
//               )}

//               {/* Enroll Tab */}
//               {activeTab === "enroll" && (
//                 <div>
//                   {(() => {
//                     // Check enrollment status
//                     const membershipId = selectedPlan.apiData?.id;
//                     const enrollment = membershipId ? checkUserEnrollment(membershipId) : null;
                    
//                     if (enrollment) {
//                       // User has already applied/enrolled
//                       switch(enrollment.status) {
//                         case "pending":
//                           return (
//                             <div style={{ textAlign: "center", padding: "40px" }}>
//                               <div style={{
//                                 width: "80px",
//                                 height: "80px",
//                                 borderRadius: "50%",
//                                 background: "#fef3c7",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 margin: "0 auto 20px",
//                                 fontSize: "2rem",
//                               }}>
//                                 ⏳
//                               </div>
//                               <h3 style={{ color: "#d97706", marginBottom: "10px" }}>
//                                 Waiting for Admin Approval
//                               </h3>
//                               <p style={{ color: "#64748b", marginBottom: "25px" }}>
//                                 Your enrollment request has been submitted and is pending admin approval.
//                                 You will be notified once it's approved.
//                               </p>
//                               <button
//                                 onClick={() => setSelectedPlan(null)}
//                                 style={styles.backBtn}
//                               >
//                                 ← Back to Memberships
//                               </button>
//                             </div>
//                           );
                        
//                         case "approved":
//                           return (
//                             <div style={{ textAlign: "center", padding: "40px" }}>
//                               <div style={{
//                                 width: "80px",
//                                 height: "80px",
//                                 borderRadius: "50%",
//                                 background: "#d1fae5",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 margin: "0 auto 20px",
//                                 fontSize: "2rem",
//                               }}>
//                                 ✅
//                               </div>
//                               <h3 style={{ color: "#059669", marginBottom: "10px" }}>
//                                 Enrollment Approved!
//                               </h3>
//                               <p style={{ color: "#64748b", marginBottom: "25px" }}>
//                                 Your enrollment has been approved. You can now proceed with payment to activate your membership.
//                               </p>
//                               <button
//                                 onClick={() => {
//                                   setEnrollmentId(enrollment.enrollmentId);
//                                   setPaymentModal(selectedPlan);
//                                 }}
//                                 style={{
//                                   ...styles.btn,
//                                   padding: "16px 40px",
//                                   fontSize: "1.1rem",
//                                   background: "linear-gradient(90deg, #10b981, #34d399)",
//                                 }}
//                               >
//                                 💳 Proceed to Payment
//                               </button>
//                               <p style={{ color: "#94a3b8", fontSize: "0.9rem", marginTop: "15px" }}>
//                                 Enrollment ID: {enrollment.enrollmentId}
//                               </p>
//                             </div>
//                           );
                        
//                         case "active":
//                           return (
//                             <div style={{ textAlign: "center", padding: "40px" }}>
//                               <div style={{
//                                 width: "80px",
//                                 height: "80px",
//                                 borderRadius: "50%",
//                                 background: "#dbeafe",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 margin: "0 auto 20px",
//                                 fontSize: "2rem",
//                               }}>
//                                 🎉
//                               </div>
//                               <h3 style={{ color: "#2563eb", marginBottom: "10px" }}>
//                                 Already Enrolled!
//                               </h3>
//                               <p style={{ color: "#64748b", marginBottom: "25px" }}>
//                                 You are already enrolled in this membership. Enjoy your learning journey!
//                               </p>
//                               <button
//                                 onClick={() => setSelectedPlan(null)}
//                                 style={styles.backBtn}
//                               >
//                                 ← Back to Memberships
//                               </button>
//                             </div>
//                           );
                        
//                         case "rejected":
//                           return (
//                             <div style={{ textAlign: "center", padding: "40px" }}>
//                               <div style={{
//                                 width: "80px",
//                                 height: "80px",
//                                 borderRadius: "50%",
//                                 background: "#fee2e2",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 margin: "0 auto 20px",
//                                 fontSize: "2rem",
//                               }}>
//                                 ❌
//                               </div>
//                               <h3 style={{ color: "#dc2626", marginBottom: "10px" }}>
//                                 Enrollment Rejected
//                               </h3>
//                               <p style={{ color: "#64748b", marginBottom: "25px" }}>
//                                 Your enrollment request was not approved. Please contact support for more information.
//                               </p>
//                               <button
//                                 onClick={() => setSelectedPlan(null)}
//                                 style={styles.backBtn}
//                               >
//                                 ← Back to Memberships
//                               </button>
//                             </div>
//                           );
                        
//                         default:
//                           // Show enrollment form for new applications
//                           return renderEnrollmentForm();
//                       }
//                     } else {
//                       // No enrollment yet - show enrollment form
//                       return renderEnrollmentForm();
//                     }
//                   })()}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Payment Modal - Only shown when enrollment is approved */}
//       {paymentModal && (
//         <div style={styles.modalBackdrop}>
//           <div style={{ ...styles.modal, maxWidth: "500px" }}>
//             <div style={styles.modalHeader}>
//               {/* Back to Plan Details Button */}
//               <button
//                 style={{
//                   ...styles.modalBackButton,
//                   ...(backHover ? styles.modalBackButtonHover : {}),
//                 }}
//                 onClick={() => setPaymentModal(null)}
//                 onMouseEnter={() => setBackHover(true)}
//                 onMouseLeave={() => setBackHover(false)}
//               >
//                 ← Back to Details
//               </button>

//               {/* Close Modal Button */}
//               <button
//                 style={{
//                   ...styles.modalClose,
//                   ...(closeHover ? styles.modalCloseHover : {}),
//                 }}
//                 onClick={() => setPaymentModal(null)}
//                 onMouseEnter={() => setCloseHover(true)}
//                 onMouseLeave={() => setCloseHover(false)}
//               >
//                 ✕
//               </button>
//               <h2 style={styles.planName}>Complete Your Payment</h2>
//               <p style={{ color: "#64748b", marginTop: "5px" }}>
//                 Enrollment ID: {enrollmentId}
//               </p>
//             </div>

//             <div style={styles.modalBody}>
//               <div style={styles.paymentSummary}>
//                 <h4 style={{ marginBottom: "20px", color: "#1e293b", textAlign: "center" }}>
//                   💳 Payment Summary
//                 </h4>

//                 <div style={{ marginBottom: "20px" }}>
//                   <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
//                     <span style={{ color: "#64748b" }}>Membership Plan:</span>
//                     <span style={{ fontWeight: "600", color: "#1e293b" }}>{paymentModal.name}</span>
//                   </div>
//                   <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
//                     <span style={{ color: "#64748b" }}>Price:</span>
//                     <span style={{ fontWeight: "600", color: "#ff7e5f", fontSize: "1.2rem" }}>
//                       {paymentModal.price}
//                     </span>
//                   </div>
//                   <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
//                     <span style={{ color: "#64748b" }}>Access Duration:</span>
//                     <span style={{ fontWeight: "600", color: "#1e293b" }}>{paymentModal.accessExpiration}</span>
//                   </div>
//                   <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
//                     <span style={{ color: "#64748b" }}>Status:</span>
//                     <span style={{ fontWeight: "600", color: "#10b981" }}>✅ Approved</span>
//                   </div>
//                 </div>

//                 <div style={{ borderTop: "2px dashed #e2e8f0", paddingTop: "20px", marginTop: "20px" }}>
//                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <span style={{ color: "#1e293b", fontWeight: "600" }}>Total Amount:</span>
//                     <span style={{ fontWeight: "700", color: "#2563eb", fontSize: "1.4rem" }}>
//                       {paymentModal.price}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div style={{ textAlign: "center", marginTop: "30px" }}>
//                 <button
//                   onClick={handlePaymentInitiation}
//                   style={{
//                     ...styles.btn,
//                     padding: "16px 40px",
//                     fontSize: "1.1rem",
//                     background: "linear-gradient(90deg, #10b981, #34d399)",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = "translateY(-2px)";
//                     e.target.style.boxShadow = "0 8px 20px rgba(16, 185, 129, 0.3)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = "translateY(0)";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 >
//                   💳 Pay Now with Razorpay
//                 </button>

//                 <p style={{ color: "#94a3b8", fontSize: "0.9rem", marginTop: "15px" }}>
//                   <span style={{ color: "#10b981" }}>🔒</span> Secure payment powered by Razorpay
//                 </p>

//                 <button
//                   onClick={() => setPaymentModal(null)}
//                   style={{
//                     ...styles.backBtn,
//                     width: "100%",
//                     marginTop: "15px",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.background = "#f1f5f9";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.background = "transparent";
//                   }}
//                 >
//                   ← Back to Details
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function MembershipUserPage() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [paymentModal, setPaymentModal] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [enrollmentData, setEnrollmentData] = useState({
    name: "",
    email: "",
    phone: "",
    background: "",
    goals: ""
  });
  const [focusedField, setFocusedField] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [closeHover, setCloseHover] = useState(false);
  const [backHover, setBackHover] = useState(false);
  const [pageCrossHover, setPageCrossHover] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [memberships, setMemberships] = useState([]);
  const [enrollmentStatus, setEnrollmentStatus] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [enrollmentId, setEnrollmentId] = useState(null);
  const [checkingApproval, setCheckingApproval] = useState(false);
  const [membershipStatus, setMembershipStatus] = useState({});
  
  const navigate = useNavigate();

  // API Configuration
  const API_BASE_URL = "https://kaasbackend.vetrinahealthcare.com/lms";
  const API_MEMBERSHIPS = `${API_BASE_URL}/membership/all/`;
  const API_MEMBERSHIP_STATUS = `${API_BASE_URL}/membership/my-status/`;

  // Fetch memberships from API
  useEffect(() => {
    fetchMemberships();
  }, []);

  // Check membership status when component loads
  useEffect(() => {
    checkMembershipStatus();
  }, []);

  // Check membership status when a plan is selected
  useEffect(() => {
    if (selectedPlan) {
      const membershipId = selectedPlan.apiData?.id;
      if (membershipId && membershipStatus[membershipId]) {
        // Status already checked, no need to re-fetch
      } else if (membershipId) {
        checkSpecificMembershipStatus(membershipId);
      }
    }
  }, [selectedPlan]);

  const fetchMemberships = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem("jwttoken") || 
                    localStorage.getItem("jwtToken") || 
                    localStorage.getItem("token");
      
      console.log("Token for memberships API:", token ? "Present" : "Missing");
      
      if (!token) {
        throw new Error("Please login to view memberships");
      }

      const response = await axios.get(API_MEMBERSHIPS, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        timeout: 10000
      });

      console.log("API Response:", response.data);

      if (response.data && Array.isArray(response.data)) {
        // Transform API data to match frontend structure
        const transformedMemberships = response.data.map(membership => ({
          id: membership.id,
          name: membership.title || "Unnamed Membership",
          type: membership.membership_type || "basic",
          price: membership.access_type === "free" ? "Free" : `₹${parseFloat(membership.price).toFixed(2)}`,
          originalPrice: membership.price,
          access_type: membership.access_type,
          instructor: "Vetrina Healthcare Pvt Ltd",
          instructorBio: "Leading veterinary education provider with expert instructors",
          description: membership.description || "Comprehensive veterinary training program",
          shortDescription: membership.intended_learner || "For veterinary professionals and students",
          coverImage: membership.cover_image || "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=600&q=60",
          promoVideo: membership.promo_video_url || "",
          
          // Use actual courses from API
          courses: membership.courses && membership.courses.length > 0 
            ? membership.courses.map(course => ({
                id: course.course_id,
                title: course.title || "Untitled Course",
                description: course.description || "",
                cover_img: course.cover_img,
                duration: "Self-paced",
                level: "Beginner",
                lessons: 0,
                objectives: [
                  "Learn course fundamentals",
                  "Understand key concepts",
                  "Apply knowledge practically"
                ],
                resources: ["Study Materials", "Video Lessons", "Quizzes"]
              }))
            : [
                {
                  id: 0,
                  title: "Coming Soon",
                  description: "Courses will be added to this membership soon.",
                  duration: "Self-paced",
                  level: "All Levels",
                  lessons: 0,
                  objectives: ["Stay tuned for course updates"],
                  resources: ["Announcements"]
                }
              ],
          
          // Create curriculum from courses
          curriculum: membership.courses && membership.courses.length > 0
            ? membership.courses.map((course, index) => ({
                name: course.title || "Untitled Course",
                duration: "Self-paced",
                type: "core",
                courseId: course.course_id
              }))
            : [
                {
                  name: "Course Content Coming Soon",
                  duration: "Self-paced",
                  type: "core"
                }
              ],
          
          features: [
            { name: "Course Certificates", icon: "🎓", included: true },
            { name: "Downloadable Resources", icon: "📥", included: true },
            { name: "Community Access", icon: "👥", included: true },
            { name: "Email Support", icon: "📧", included: true },
            { name: "Live Q&A Sessions", icon: "🎥", included: membership.membership_type === "pro" || membership.membership_type === "enterprise" },
            { name: "1-on-1 Mentoring", icon: "🎯", included: membership.membership_type === "enterprise" }
          ],
          rating: 4.5,
          reviews: membership.reviews_count || 0,
          students: membership.enrolled_students || 0,
          accessExpiration: membership.expiry_type === "lifetime" ? "Lifetime" : 
                           membership.expiry_months ? `${membership.expiry_months} months` : "Monthly",
          category: membership.category || "Veterinary Education",
          tags: membership.tags || ["veterinary", "education", "training"],
          whatsIncluded: [
            "Access to all course materials",
            "Video lectures and tutorials",
            "Downloadable resources",
            "Certificate of completion",
            "Community forum access"
          ],
          intendedLearners: membership.intended_learner ? 
                           [membership.intended_learner] : 
                           ["Veterinary Students", "Animal Care Professionals"],
          status: membership.status,
          apiData: membership // Keep original API data
        }));
        
        setMemberships(transformedMemberships);
        
        // For development/testing - add mock data if API returns empty
        if (transformedMemberships.length === 0) {
          console.log("No memberships found, using sample data");
          setMemberships(getSampleMemberships());
        }
      } else {
        console.log("Unexpected response format, using sample data");
        setMemberships(getSampleMemberships());
      }
    } catch (error) {
      console.error("Error fetching memberships:", error);
      
      let errorMsg = "Failed to load memberships. ";
      if (error.response) {
        if (error.response.status === 401) {
          errorMsg = "Please login to view memberships";
        } else if (error.response.status === 403) {
          errorMsg = "You don't have permission to view memberships";
        } else {
          errorMsg += `Server error: ${error.response.status}`;
        }
      } else if (error.request) {
        errorMsg = "Network error. Please check your connection.";
      } else {
        errorMsg += error.message;
      }
      
      setError(errorMsg);
      
      // Use sample data for development
      console.log("Using sample data due to API error");
      setMemberships(getSampleMemberships());
    } finally {
      setLoading(false);
    }
  };

  // NEW: Check membership status from /membership/my-status/
  const checkMembershipStatus = async () => {
    try {
      const token = localStorage.getItem("jwttoken") || 
                    localStorage.getItem("jwtToken") || 
                    localStorage.getItem("token");
      
      if (!token) {
        console.log("No token found, skipping membership status check");
        return;
      }

      console.log("Checking membership status from API...");
      
      const response = await axios.get(API_MEMBERSHIP_STATUS, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      console.log("Membership status response:", response.data);

      if (response.data) {
        // The API returns a single object, not an array
        const statusData = response.data;
        
        // Store the status in state
        setMembershipStatus(prev => ({
          ...prev,
          [statusData.membership_title]: {
            is_member: statusData.is_member,
            membership_title: statusData.membership_title,
            membership_type: statusData.membership_type,
            expiry_date: statusData.expiry_date
          }
        }));
        
        // Also store in localStorage for easy access
        localStorage.setItem('membershipStatus', JSON.stringify(statusData));
        
        return statusData;
      }
      return null;
    } catch (error) {
      console.error("Error checking membership status:", error);
      
      // Don't show error to user for status check
      if (error.response && error.response.status === 404) {
        console.log("User has no active membership yet");
        return { is_member: false };
      }
      return null;
    }
  };

  // NEW: Check specific membership status
  const checkSpecificMembershipStatus = async (membershipId) => {
    try {
      setCheckingApproval(true);
      
      const token = localStorage.getItem("jwttoken") || 
                    localStorage.getItem("jwtToken") || 
                    localStorage.getItem("token");
      
      if (!token) {
        return { is_member: false };
      }

      // First, check if we already have status in localStorage
      const storedStatus = localStorage.getItem('membershipStatus');
      if (storedStatus) {
        const parsedStatus = JSON.parse(storedStatus);
        const selectedMembership = memberships.find(m => m.apiData?.id === membershipId);
        
        if (selectedMembership && parsedStatus.membership_title === selectedMembership.name) {
          setMembershipStatus(prev => ({
            ...prev,
            [membershipId]: parsedStatus
          }));
          return parsedStatus;
        }
      }

      // If not found, check from API
      const statusData = await checkMembershipStatus();
      
      if (statusData) {
        const selectedMembership = memberships.find(m => m.apiData?.id === membershipId);
        
        if (selectedMembership && statusData.membership_title === selectedMembership.name) {
          setMembershipStatus(prev => ({
            ...prev,
            [membershipId]: statusData
          }));
          return statusData;
        }
      }
      
      return { is_member: false };
    } catch (error) {
      console.error("Error checking specific membership status:", error);
      return { is_member: false };
    } finally {
      setCheckingApproval(false);
    }
  };

  // Sample data for development
  const getSampleMemberships = () => [
    {
      id: 1,
      name: "Basic Veterinary Membership",
      type: "basic",
      price: "Free",
      instructor: "Dr. Rajesh Sharma",
      instructorBio: "15+ years in veterinary education, specialized in clinical training",
      description: "Perfect for beginners to start learning. Includes limited course access and community support.",
      shortDescription: "Essential veterinary knowledge for beginners and students",
      coverImage: "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=600&q=60",
      promoVideo: "https://www.youtube.com/embed/J4kzKpMP6o8",
      courses: [
        {
          id: 87,
          title: "Test_1",
          description: "testing method",
          cover_img: "https://vetrina-kaas.s3.us-west-2.amazonaws.com/courses/covers/download_1.jpeg",
          duration: "Self-paced",
          level: "Beginner",
          lessons: 0,
          objectives: [
            "Learn the fundamentals of nutrition",
            "Understand diet formulation",
            "Identify nutritional requirements",
            "Plan balanced diets for pets"
          ],
          resources: ["Nutrition Charts", "Diet Plans", "Quizzes", "Case Studies"]
        }
      ],
      curriculum: [
        { name: "Test_1", duration: "Self-paced", type: "core", courseId: 87 }
      ],
      features: [
        { name: "Course Certificates", icon: "🎓", included: true },
        { name: "Downloadable Resources", icon: "📥", included: true },
        { name: "Community Access", icon: "👥", included: true },
        { name: "Email Support", icon: "📧", included: true },
        { name: "Live Q&A Sessions", icon: "🎥", included: false },
        { name: "1-on-1 Mentoring", icon: "🎯", included: false }
      ],
      rating: 4.5,
      reviews: 234,
      students: 1250,
      accessExpiration: "Lifetime",
      category: "Clinical Foundations",
      tags: ["beginner", "nutrition", "fundamentals"],
      whatsIncluded: [
        "Lifetime access to basic courses",
        "8+ hours of video content",
        "12 downloadable resources",
        "Mobile app access",
        "Certificate of completion"
      ],
      intendedLearners: ["Veterinary Students", "Animal Care Assistants", "Pet Owners", "Shelter Staff"],
      apiData: {
        id: 1,
        title: "Basic Veterinary Membership",
        membership_type: "basic",
        access_type: "free",
        price: "0.00"
      }
    }
  ];

  // Helper function to check enrollment status from localStorage
  const checkUserEnrollment = (membershipId) => {
    try {
      const userEnrollments = JSON.parse(localStorage.getItem('userEnrollments') || '{}');
      return userEnrollments[membershipId] || null;
    } catch (error) {
      console.error("Error checking enrollment:", error);
      return null;
    }
  };

  // Handle enrollment submission
  const handleEnrollmentSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedPlan) {
      alert("Please select a membership plan first");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const token = localStorage.getItem("jwttoken") || 
                    localStorage.getItem("jwtToken") || 
                    localStorage.getItem("token");
      
      if (!token) {
        alert("Please login to enroll");
        navigate("/login");
        return;
      }

      // Get the ACTUAL membership ID from apiData
      const membershipId = selectedPlan.apiData?.id;
      const isFreeMembership = selectedPlan.access_type === "free" || selectedPlan.price === "Free";
      
      if (!membershipId) {
        throw new Error("Membership ID not found in API data");
      }
      
      // Prepare enrollment data for API
      const enrollmentPayload = {
        name: enrollmentData.name,
        email: enrollmentData.email,
        phone: enrollmentData.phone,
        background: enrollmentData.background,
        goals: enrollmentData.goals
      };

      console.log("Submitting enrollment request to:", `${API_BASE_URL}/membership/enroll/${membershipId}/`);
      console.log("Membership ID from API:", membershipId);
      console.log("Payload:", enrollmentPayload);

      // Submit enrollment request to /membership/enroll/<membership_id>/
      const response = await axios.post(
        `${API_BASE_URL}/membership/enroll/${membershipId}/`,
        enrollmentPayload,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      console.log("Enrollment response:", response.data);

      if (response.data) {
        // Get enrollment ID from response
        const enrollmentId = response.data.enrollment_id || response.data.id;
        
        if (!enrollmentId) {
          throw new Error("No enrollment ID received from server");
        }
        
        setEnrollmentId(enrollmentId);
        
        // Store enrollment status locally
        const userEnrollments = JSON.parse(localStorage.getItem('userEnrollments') || '{}');
        userEnrollments[membershipId] = {
          status: "pending",
          enrollmentId: enrollmentId,
          date: new Date().toISOString(),
          membershipId: membershipId,
          membershipName: selectedPlan.name,
          lastChecked: new Date().toISOString()
        };
        localStorage.setItem('userEnrollments', JSON.stringify(userEnrollments));
        
        // Update enrollment status state
        setEnrollmentStatus(prev => ({
          ...prev,
          [membershipId]: "pending"
        }));
        
        // Clear any previous membership status since this is a new application
        setMembershipStatus(prev => ({
          ...prev,
          [membershipId]: { is_member: false }
        }));
        
        if (isFreeMembership) {
          alert("🎉 Your enrollment request has been submitted for admin approval!");
          setSelectedPlan(null);
        } else {
          alert("✅ Enrollment request submitted! Waiting for admin approval.");
        }
        
        // Reset form
        setEnrollmentData({
          name: "",
          email: "",
          phone: "",
          background: "",
          goals: ""
        });
      } else {
        alert("Enrollment submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting enrollment:", error);
      
      let errorMsg = "Failed to submit enrollment. ";
      if (error.response) {
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        
        if (error.response.status === 400) {
          errorMsg = "Please fill all required fields correctly.";
          if (error.response.data) {
            const errors = Object.values(error.response.data).flat().join(', ');
            errorMsg += ` Errors: ${errors}`;
          }
        } else if (error.response.status === 401) {
          errorMsg = "Session expired. Please login again.";
          navigate("/login");
        } else if (error.response.status === 403) {
          errorMsg = "You don't have permission to enroll.";
        } else if (error.response.status === 404) {
          errorMsg = "Membership not found. The membership ID might be incorrect.";
        } else if (error.response.status === 409) {
          errorMsg = "You have already enrolled in this membership.";
        } else {
          errorMsg += `Server error: ${error.response.status}`;
          if (error.response.data?.detail) {
            errorMsg += ` - ${error.response.data.detail}`;
          }
        }
      } else if (error.request) {
        errorMsg = "Network error. Please check your connection.";
      } else {
        errorMsg += error.message;
      }
      
      alert(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  // NEW: Refresh membership status
  const refreshMembershipStatus = async () => {
    try {
      setCheckingApproval(true);
      const statusData = await checkMembershipStatus();
      
      if (statusData) {
        // Find which membership this status belongs to
        const selectedMembership = memberships.find(m => 
          m.name === statusData.membership_title || 
          m.apiData?.title === statusData.membership_title
        );
        
        if (selectedMembership) {
          const membershipId = selectedMembership.apiData?.id;
          setMembershipStatus(prev => ({
            ...prev,
            [membershipId]: statusData
          }));
          
          return {
            statusData,
            membershipId,
            membershipName: selectedMembership.name
          };
        }
      }
      return null;
    } catch (error) {
      console.error("Error refreshing membership status:", error);
      return null;
    } finally {
      setCheckingApproval(false);
    }
  };

  // Handle going back to previous page
  const handleGoBack = () => {
    navigate(-1);
  };

  // Render star ratings
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<span key={i} style={{ color: "#fbbf24" }}>★</span>);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<span key={i} style={{ color: "#fbbf24" }}>☆</span>);
      } else {
        stars.push(<span key={i} style={{ color: "#e2e8f0" }}>★</span>);
      }
    }
    return stars;
  };

  // NEW: Function to check if user is a member for a specific plan
  const isUserMember = (membershipId) => {
    const status = membershipStatus[membershipId];
    if (status && status.is_member === true) {
      return true;
    }
    
    // Also check localStorage for backward compatibility
    const storedStatus = localStorage.getItem('membershipStatus');
    if (storedStatus) {
      const parsedStatus = JSON.parse(storedStatus);
      const selectedMembership = memberships.find(m => m.apiData?.id === membershipId);
      
      if (selectedMembership && parsedStatus.membership_title === selectedMembership.name) {
        return parsedStatus.is_member === true;
      }
    }
    
    return false;
  };

  // Styling remains the same
  const styles = {
    page: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
      padding: "40px 20px 40px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      position: "relative",
    },
    pageHeader: {
      position: "absolute",
      top: "20px",
      right: "20px",
      zIndex: 100,
    },
    pageCrossButton: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      background: "rgba(255, 255, 255, 0.9)",
      border: "0px solid #e2e8f0",
      color: "#64748b",
      fontSize: "1.5rem",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease",
    },
    pageCrossButtonHover: {
      background: "#ef4444",
      color: "#fff",
      borderColor: "#ef4444",
      transform: "rotate(90deg) scale(1.1)",
      boxShadow: "0 6px 20px rgba(239, 68, 68, 0.3)",
    },
    title: {
      textAlign: "center",
      fontSize: "3rem",
      fontWeight: "800",
      background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      marginBottom: "10px",
    },
    subtitle: {
      textAlign: "center",
      color: "#64748b",
      marginBottom: "10px",
      fontSize: "1.1rem",
      maxWidth: "600px",
      margin: "0 auto",
      lineHeight: "1.6",
    },
    loadingContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "50vh",
      gap: "20px",
    },
    loader: {
      width: "50px",
      height: "50px",
      border: "5px solid #e2e8f0",
      borderTopColor: "#8e44ad",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    errorContainer: {
      background: "#fee2e2",
      border: "1px solid #fecaca",
      borderRadius: "10px",
      padding: "20px",
      maxWidth: "600px",
      margin: "30px auto",
      textAlign: "center",
    },
    errorText: {
      color: "#dc2626",
      marginBottom: "15px",
    },
    retryButton: {
      background: "#8e44ad",
      color: "white",
      border: "none",
      padding: "10px 20px",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "0.9rem",
      fontWeight: "600",
      transition: "all 0.2s ease",
    },
    cardGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
      gap: "30px",
      maxWidth: "1200px",
      margin: "0 auto 60px",
    },
    card: {
      background: "rgba(255, 255, 255, 0.95)",
      borderRadius: "20px",
      padding: "25px",
      boxShadow: "0 8px 30px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
      border: "0px solid transparent",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    cardHover: {
      transform: "translateY(10px)",
      boxShadow: "0 20px 40px rgba(37, 99, 235, 0.15)",
      border: "2px solid #8e44ad",
    },
    image: {
      width: "100%",
      height: "180px",
      objectFit: "cover",
      borderRadius: "15px",
      marginBottom: "20px",
    },
    planName: {
      fontSize: "1.5rem",
      fontWeight: "700",
      background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      marginBottom: "8px",
    },
    price: {
      fontWeight: "700",
      fontSize: "1.4rem",
      color: "#ff7e5f",
      marginBottom: "5px",
    },
    instructor: {
      color: "#64748b",
      fontSize: "0.9rem",
      marginBottom: "15px",
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
    desc: {
      color: "#475569",
      margin: "15px 0 20px",
      lineHeight: "1.6",
      flex: "1",
      fontSize: "0.95rem",
    },
    badge: {
      display: "inline-block",
      padding: "6px 12px",
      borderRadius: "20px",
      fontSize: "0.75rem",
      fontWeight: "600",
      marginRight: "8px",
      marginBottom: "10px",
    },
    btn: {
      padding: "14px 20px",
      background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
      color: "#fff",
      fontWeight: "600",
      border: "none",
      borderRadius: "12px",
      cursor: "pointer",
      fontSize: "1rem",
      transition: "all 0.3s ease",
      marginTop: "15px",
    },
    backBtn: {
      padding: "10px 20px",
      background: "transparent",
      color: "#64748b",
      fontWeight: "600",
      border: "2px solid #e2e8f0",
      borderRadius: "10px",
      cursor: "pointer",
      fontSize: "0.95rem",
      transition: "all 0.2s ease",
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
    },
    btnHover: {
      background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(136, 4, 212, 0.3)",
    },
    backBtnHover: {
      background: "#f1f5f9",
      borderColor: "#cbd5e1",
      transform: "translateX(-3px)",
    },
    modalBackdrop: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, 0.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10000,
      padding: "20px",
      backdropFilter: "blur(4px)",
    },
    modal: {
      background: "#fff",
      borderRadius: "24px",
      width: "100%",
      maxWidth: "900px",
      maxHeight: "90vh",
      overflow: "hidden",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      display: "flex",
      flexDirection: "column",
    },
    modalHeader: {
      padding: "25px 30px 20px",
      borderBottom: "1px solid #e2e8f0",
      position: "relative",
      background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
    },
    modalClose: {
      position: "absolute",
      right: "2px",
      top: "2px",
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      background: "rgba(255, 255, 255, 0.9)",
      border: "0px solid #e2e8f0",
      color: "#64748b",
      fontSize: "1.2rem",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      zIndex: 10,
    },
    modalCloseHover: {
      background: "#ef4444",
      color: "#fff",
      borderColor: "#ef4444",
      transform: "rotate(90deg)",
    },
    modalBody: {
      padding: "30px",
      overflowY: "auto",
      flex: "1",
    },
    tabsContainer: {
      display: "flex",
      borderBottom: "2px solid #e2e8f0",
      marginBottom: "30px",
      gap: "10px",
    },
    tab: {
      padding: "12px 24px",
      background: "none",
      border: "none",
      fontSize: "0.95rem",
      fontWeight: "600",
      color: "#64748b",
      cursor: "pointer",
      position: "relative",
      transition: "all 0.2s ease",
    },
    tabActive: {
      color: "#8e44ad",
    },
    tabIndicator: {
      position: "absolute",
      bottom: "-2px",
      left: 0,
      right: 0,
      height: "2px",
      background: "#8e44ad",
    },
    sectionTitle: {
      fontSize: "1.3rem",
      fontWeight: "700",
      color: "#1e293b",
      margin: "25px 0 15px",
      paddingBottom: "10px",
      borderBottom: "2px solid #f1f5f9",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    featureGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "15px",
      margin: "20px 0",
    },
    featureItem: {
      padding: "15px",
      background: "#f8fafc",
      borderRadius: "12px",
      border: "1px solid #e2e8f0",
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    courseCard: {
      background: "#f8fafc",
      borderRadius: "12px",
      padding: "20px",
      marginBottom: "20px",
      borderLeft: "4px solid #ff7e5f",
    },
    formGroup: {
      marginBottom: "20px",
    },
    formLabel: {
      display: "block",
      marginBottom: "8px",
      fontWeight: "600",
      color: "#1e293b",
    },
    formInput: {
      width: "100%",
      display: "block",
      padding: "12px 16px",
      border: "1.5px solid #e2e8f0",
      borderRadius: "10px",
      fontSize: "1rem",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
      outline: "none",
      background: "#fff"
    },
    formInputFocus: {
      borderColor: "#8e44ad",
      boxShadow: "0 0 0 3px rgba(142, 68, 173, 0.2)",
      background: "#fff",
    },
    statsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "20px",
      margin: "25px 0",
      padding: "20px",
      background: "#f8fafc",
      borderRadius: "15px",
    },
    statItem: {
      textAlign: "center",
    },
    statValue: {
      fontSize: "1.8rem",
      fontWeight: "700",
      color: "#ff7e5f",
      marginBottom: "5px",
    },
    statLabel: {
      fontSize: "0.9rem",
      color: "#64748b",
    },
    paymentSummary: {
      background: "#f8fafc",
      borderRadius: "15px",
      padding: "25px",
      margin: "25px 0",
      border: "1px solid #e2e8f0",
    },
    modalBackButton: {
      position: "absolute",
      left: "25px",
      top: "25px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      background: "rgba(255, 255, 255, 0.9)",
      border: "1px solid #e2e8f0",
      borderRadius: "10px",
      padding: "8px 16px",
      color: "#64748b",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s ease",
      zIndex: 10,
    },
    modalBackButtonHover: {
      background: "#f1f5f9",
      borderColor: "#cbd5e1",
      transform: "translateX(-3px)",
    },
    statusBadge: (status) => ({
      display: "inline-block",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.7rem",
      fontWeight: "600",
      marginLeft: "8px",
      background: status === "published" ? "#10b98120" : "#fbbf2420",
      color: status === "published" ? "#10b981" : "#f59e0b",
    }),
    enrollmentStatusBadge: (status) => ({
      display: "inline-block",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "0.75rem",
      fontWeight: "600",
      marginLeft: "10px",
      background: status === "pending" ? "#fef3c7" : 
                status === "approved" ? "#d1fae5" :
                status === "active" ? "#dbeafe" :
                status === "rejected" ? "#fee2e2" : "#f1f5f9",
      color: status === "pending" ? "#d97706" :
             status === "approved" ? "#059669" :
             status === "active" ? "#2563eb" :
             status === "rejected" ? "#dc2626" : "#64748b",
    }),
    memberBadge: (isMember) => ({
      display: "inline-block",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "0.75rem",
      fontWeight: "600",
      marginLeft: "10px",
      background: isMember ? "#d1fae5" : "#fef3c7",
      color: isMember ? "#059669" : "#d97706",
    }),
  };

  // Add CSS for loader animation
  const cssStyles = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  // Function to render enrollment form
  const renderEnrollmentForm = () => {
    const isFreeMembership = selectedPlan.access_type === "free" || selectedPlan.price === "Free";
    
    return (
      <>
        <h3 style={styles.sectionTitle}>📝 Enrollment Application</h3>
        <p style={{ color: "#64748b", marginBottom: "25px" }}>
          Complete the form below to apply for enrollment. {isFreeMembership
            ? "Free memberships require admin approval."
            : "Payment will be required after admin approval."}
        </p>

        <form onSubmit={handleEnrollmentSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Full Name *</label>
              <input
                type="text"
                required
                style={
                  focusedField === "name"
                    ? { ...styles.formInput, ...styles.formInputFocus }
                    : styles.formInput
                }
                onFocus={() => setFocusedField("name")}
                onBlur={() => setFocusedField(null)}
                value={enrollmentData.name}
                onChange={(e) => setEnrollmentData({ ...enrollmentData, name: e.target.value })}
                placeholder="Enter your full name"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Email Address *</label>
              <input
                type="email"
                required
                style={
                  focusedField === "email"
                    ? { ...styles.formInput, ...styles.formInputFocus }
                    : styles.formInput
                }
                onFocus={() => setFocusedField("email")}
                onBlur={() => setFocusedField(null)}
                value={enrollmentData.email}
                onChange={(e) => setEnrollmentData({ ...enrollmentData, email: e.target.value })}
                placeholder="Enter your email"
              />
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Phone Number *</label>
              <input
                type="tel"
                required
                style={
                  focusedField === "tel"
                    ? { ...styles.formInput, ...styles.formInputFocus }
                    : styles.formInput
                }
                onFocus={() => setFocusedField("tel")}
                onBlur={() => setFocusedField(null)}
                value={enrollmentData.phone}
                onChange={(e) => setEnrollmentData({ ...enrollmentData, phone: e.target.value })}
                placeholder="Enter your phone number"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Current Position</label>
              <input
                type="text"
                style={
                  focusedField === "position"
                    ? { ...styles.formInput, ...styles.formInputFocus }
                    : styles.formInput
                }
                onFocus={() => setFocusedField("position")}
                onBlur={() => setFocusedField(null)}
                placeholder="e.g., Veterinary Assistant, Student, etc."
              />
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Professional Background *</label>
            <textarea
              required
              rows="3"
              style={
                focusedField === "professionalBackground"
                  ? { ...styles.formInput, ...styles.formInputFocus }
                  : styles.formInput
              }
              onFocus={() => setFocusedField("professionalBackground")}
              onBlur={() => setFocusedField(null)}
              value={enrollmentData.background}
              onChange={(e) => setEnrollmentData({ ...enrollmentData, background: e.target.value })}
              placeholder="Tell us about your veterinary background, education, and experience..."
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Learning Objectives & Career Goals *</label>
            <textarea
              required
              rows="3"
              style={
                focusedField === "goals"
                  ? { ...styles.formInput, ...styles.formInputFocus }
                  : styles.formInput
              }
              onFocus={() => setFocusedField("goals")}
              onBlur={() => setFocusedField(null)}
              value={enrollmentData.goals}
              onChange={(e) => setEnrollmentData({ ...enrollmentData, goals: e.target.value })}
              placeholder="What specific skills do you want to develop? How will this membership help your career?"
            />
          </div>

          {/* Membership Summary */}
          <div style={styles.paymentSummary}>
            <h4 style={{ marginBottom: "15px", color: "#1e293b" }}>📋 Membership Summary</h4>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
              <div>
                <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Plan Type</div>
                <div style={{ fontWeight: "600", color: "#1e293b" }}>{selectedPlan.name}</div>
              </div>
              <div>
                <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Price</div>
                <div style={{ fontWeight: "600", color: "#ff7e5f" }}>{selectedPlan.price}</div>
              </div>
              <div>
                <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Access Duration</div>
                <div style={{ fontWeight: "600", color: "#1e293b" }}>{selectedPlan.accessExpiration}</div>
              </div>
              <div>
                <div style={{ color: "#64748b", fontSize: "0.9rem" }}>Courses Included</div>
                <div style={{ fontWeight: "600", color: "#1e293b" }}>{selectedPlan.courses.length}</div>
              </div>
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <button
              type="submit"
              style={{
                ...styles.btn,
                padding: "16px 40px",
                fontSize: "1.1rem",
                background: isFreeMembership
                  ? "linear-gradient(90deg, #10b981, #34d399)"
                  : "linear-gradient(90deg, #ff7e5f, #8e44ad)",
                opacity: isSubmitting ? 0.7 : 1,
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
              onMouseEnter={(e) => {
                if (!isSubmitting) {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = isFreeMembership
                    ? "0 8px 20px rgba(16, 185, 129, 0.3)"
                    : "0 8px 20px rgba(37, 99, 235, 0.3)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmitting) {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>⏳ Submitting...</>
              ) : isFreeMembership ? (
                <>🚀 Submit Free Enrollment Request</>
              ) : (
                <>📝 Submit Enrollment Request</>
              )}
            </button>
            <p style={{ color: "#94a3b8", fontSize: "0.9rem", marginTop: "15px" }}>
              <span style={{ color: "#10b981" }}>✓</span> Your information is secure and encrypted
            </p>
          </div>
        </form>
      </>
    );
  };

  // NEW: Render pending enrollment view
  const renderPendingEnrollmentView = () => {
    const membershipId = selectedPlan.apiData?.id;
    const isMember = membershipId ? isUserMember(membershipId) : false;
    
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        {isMember ? (
          <>
            <div style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "#d1fae5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              fontSize: "2rem",
            }}>
              ✅
            </div>
            <h3 style={{ color: "#059669", marginBottom: "10px" }}>
              Membership Approved!
            </h3>
            <p style={{ color: "#64748b", marginBottom: "25px" }}>
              Congratulations! Your membership has been approved by the admin.
              {selectedPlan.access_type !== "free" && selectedPlan.price !== "Free" 
                ? " Please proceed with payment to activate your membership."
                : " Your membership is now active!"}
            </p>
            
            {/* Show payment button only for paid memberships */}
            {selectedPlan.access_type !== "free" && selectedPlan.price !== "Free" ? (
              <button
                onClick={() => {
                  // For now, show a message that payment integration is coming soon
                  alert("Payment integration is coming soon! For now, your membership is approved. You'll be notified when payment is ready.");
                  setSelectedPlan(null);
                }}
                style={{
                  ...styles.btn,
                  padding: "16px 40px",
                  fontSize: "1.1rem",
                  background: "linear-gradient(90deg, #10b981, #34d399)",
                  marginBottom: "15px",
                }}
              >
                💳 Proceed to Payment (Coming Soon)
              </button>
            ) : (
              <button
                onClick={() => {
                  alert("🎉 Your free membership is now active! You can access all the courses.");
                  setSelectedPlan(null);
                }}
                style={{
                  ...styles.btn,
                  padding: "16px 40px",
                  fontSize: "1.1rem",
                  background: "linear-gradient(90deg, #10b981, #34d399)",
                  marginBottom: "15px",
                }}
              >
                🎉 Access Membership
              </button>
            )}
            
            <button
              onClick={() => setSelectedPlan(null)}
              style={styles.backBtn}
            >
              ← Back to Memberships
            </button>
          </>
        ) : (
          <>
            <div style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "#fef3c7",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              fontSize: "2rem",
            }}>
              ⏳
            </div>
            <h3 style={{ color: "#d97706", marginBottom: "10px" }}>
              Waiting for Admin Approval
            </h3>
            <p style={{ color: "#64748b", marginBottom: "25px" }}>
              Your enrollment request has been submitted and is pending admin approval.
              You will be notified once it's approved. Please check back later.
            </p>
            
            <div style={{ marginBottom: "20px" }}>
              <button
                onClick={async () => {
                  const result = await refreshMembershipStatus();
                  if (result && result.statusData.is_member) {
                    alert(`🎉 Your membership "${result.membershipName}" has been approved!`);
                    // Refresh the view
                    setSelectedPlan(selectedPlan);
                  } else {
                    alert("⏳ Still waiting for admin approval. Please check back later.");
                  }
                }}
                style={{
                  ...styles.btn,
                  background: "linear-gradient(90deg, #f59e0b, #fbbf24)",
                  padding: "12px 24px",
                }}
                disabled={checkingApproval}
              >
                {checkingApproval ? "Checking..." : "🔄 Check Approval Status"}
              </button>
            </div>
            
            <button
              onClick={() => setSelectedPlan(null)}
              style={styles.backBtn}
            >
              ← Back to Memberships
            </button>
          </>
        )}
      </div>
    );
  };

  return (
    <div style={styles.page}>
      <style>{cssStyles}</style>
      
      {/* Cross Button on Main Page */}
      <div style={styles.pageHeader}>
        <button
          style={{
            ...styles.pageCrossButton,
            ...(pageCrossHover ? styles.pageCrossButtonHover : {}),
          }}
          onClick={handleGoBack}
          onMouseEnter={() => setPageCrossHover(true)}
          onMouseLeave={() => setPageCrossHover(false)}
          title="Close Membership Page"
        >
          ✕
        </button>
      </div>

      <h1 style={styles.title}>VetLearn Membership Plans</h1>
      <p style={styles.subtitle}>
        Choose from our expertly crafted membership tiers designed to match your veterinary career goals.
        Transform your skills with structured learning paths and expert mentorship.
      </p>

      {/* Loading State */}
      {loading && (
        <div style={styles.loadingContainer}>
          <div style={styles.loader}></div>
          <p style={{ color: "#64748b" }}>Loading memberships...</p>
        </div>
      )}

      {/* Error State */}
      {error && !loading && (
        <div style={styles.errorContainer}>
          <p style={styles.errorText}>{error}</p>
          <button 
            style={styles.retryButton}
            onClick={fetchMemberships}
            onMouseEnter={(e) => e.target.style.opacity = "0.8"}
            onMouseLeave={(e) => e.target.style.opacity = "1"}
          >
            Retry Loading
          </button>
        </div>
      )}

      {/* Membership Cards Grid */}
      {!loading && !error && memberships.length > 0 && (
        <div style={styles.cardGrid}>
          {memberships.map((plan) => {
            // Get the ACTUAL API membership ID
            const apiMembershipId = plan.apiData?.id;
            const enrollment = apiMembershipId ? checkUserEnrollment(apiMembershipId) : null;
            const isMember = apiMembershipId ? isUserMember(apiMembershipId) : false;
            
            return (
              <div
                key={plan.id}
                style={{
                  ...styles.card,
                  ...(hoveredCard === plan.id ? styles.cardHover : {}),
                }}
                onMouseEnter={() => setHoveredCard(plan.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <img src={plan.coverImage} alt={plan.name} style={styles.image} />
                <div style={styles.planName}>
                  {plan.name}
                  <span style={styles.statusBadge(plan.status)}>
                    {plan.status || "active"}
                  </span>
                  {/* Show member badge if user is already a member */}
                  {isMember && (
                    <span style={styles.memberBadge(true)}>
                      ✅ Member
                    </span>
                  )}
                </div>
                <div style={styles.price}>{plan.price}</div>
                <div style={styles.instructor}>
                  <span style={{ color: "#ff7e5f" }}>👨‍🏫</span>
                  Instructor: <strong>{plan.instructor}</strong>
                </div>
                <p style={styles.desc}>{plan.description}</p>

                <div style={{ marginTop: "auto" }}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    {renderStars(plan.rating)}
                    <span style={{ marginLeft: "8px", color: "#64748b", fontSize: "0.9rem" }}>
                      ({plan.rating}) • {plan.students} students
                    </span>
                  </div>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "15px" }}>
                    {plan.tags.slice(0, 3).map((tag, idx) => (
                      <span
                        key={idx}
                        style={{
                          ...styles.badge,
                          background: idx === 0 ? "#dbeafe" : "#f1f5f9",
                          color: idx === 0 ? "#ff7e5f" : "#695b47ff",
                        }}
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* VIEW DETAILS BUTTON */}
                <button
                  style={{ 
                    ...styles.btn, 
                    width: "100%",
                    background: isMember 
                      ? "linear-gradient(90deg, #10b981, #34d399)" 
                      : "linear-gradient(90deg, #ff7e5f, #8e44ad)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = isMember
                      ? "0 8px 20px rgba(16, 185, 129, 0.3)"
                      : "0 8px 20px rgba(83, 6, 146, 0.22)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "none";
                  }}
                  onClick={() => {
                    setSelectedPlan(plan);
                    setActiveTab("overview");
                  }}
                >
                  {isMember ? "✅ View Membership" : "View Details & Enroll"}
                </button>
                
                {/* Enrollment Status Indicator */}
                {apiMembershipId && enrollment && (
                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <span style={{
                      display: "inline-block",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      backgroundColor: isMember 
                        ? "#d1fae5" 
                        : enrollment.status === "pending" 
                          ? "#fef3c7" 
                          : enrollment.status === "rejected" 
                            ? "#fee2e2" 
                            : "#f1f5f9",
                      color: isMember 
                        ? "#059669" 
                        : enrollment.status === "pending" 
                          ? "#d97706" 
                          : enrollment.status === "rejected" 
                            ? "#dc2626" 
                            : "#64748b",
                    }}>
                      {isMember 
                        ? "✅ Approved Member" 
                        : enrollment.status === "pending" 
                          ? "⏳ Waiting for approval" 
                          : enrollment.status === "rejected" 
                            ? "❌ Enrollment rejected" 
                            : enrollment.status}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* No Memberships State */}
      {!loading && !error && memberships.length === 0 && (
        <div style={{ textAlign: "center", padding: "50px", color: "#64748b" }}>
          <h3>No membership plans available at the moment.</h3>
          <p>Please check back later or contact support.</p>
        </div>
      )}

      {/* Plan Details Modal */}
      {selectedPlan && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modal}>
            {/* Modal Header */}
            <div style={styles.modalHeader}>
              <button
                style={{
                  ...styles.modalClose,
                  ...(closeHover ? styles.modalCloseHover : {}),
                }}
                onClick={() => setSelectedPlan(null)}
                onMouseEnter={() => setCloseHover(true)}
                onMouseLeave={() => setCloseHover(false)}
              >
                ✕
              </button>

              <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                <div>
                  <h2 style={styles.planName}>{selectedPlan.name}</h2>
                  <div style={{ display: "flex", alignItems: "center", gap: "15px", marginTop: "10px" }}>
                    <span style={styles.price}>{selectedPlan.price}</span>
                    <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
                      <strong>Access:</strong> {selectedPlan.accessExpiration}
                    </span>
                    <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
                      <strong>Category:</strong> {selectedPlan.category}
                    </span>
                    
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {renderStars(selectedPlan.rating)}
                  <span style={{ marginLeft: "8px", color: "#64748b" }}>
                    {selectedPlan.rating} ({selectedPlan.reviews} reviews)
                  </span>
                </div>
              </div>
            </div>

            {/* Modal Body */}
            <div style={styles.modalBody}>
              {/* Tabs Navigation */}
              <div style={styles.tabsContainer}>
                {["overview", "curriculum", "instructor", "enroll"].map((tab) => (
                  <button
                    key={tab}
                    style={{
                      ...styles.tab,
                      ...(activeTab === tab ? styles.tabActive : {}),
                    }}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    {activeTab === tab && <span style={styles.tabIndicator} />}
                  </button>
                ))}
              </div>

              {/* Overview Tab */}
              {activeTab === "overview" && (
                <div>
                  <p style={{ color: "#475569", lineHeight: "1.8", marginBottom: "25px" }}>
                    {selectedPlan.description}
                  </p>

                  {/* Stats */}
                  <div style={styles.statsContainer}>
                    <div style={styles.statItem}>
                      <div style={styles.statValue}>{selectedPlan.students}+</div>
                      <div style={styles.statLabel}>Students Enrolled</div>
                    </div>
                    <div style={styles.statItem}>
                      <div style={styles.statValue}>{selectedPlan.courses.length}</div>
                      <div style={styles.statLabel}>Courses Included</div>
                    </div>
                    <div style={styles.statItem}>
                      <div style={styles.statValue}>{selectedPlan.accessExpiration}</div>
                      <div style={styles.statLabel}>Access Duration</div>
                    </div>
                    <div style={styles.statItem}>
                      <div style={styles.statValue}>{selectedPlan.rating}/5</div>
                      <div style={styles.statLabel}>Average Rating</div>
                    </div>
                  </div>

                  {/* What's Included */}
                  <div>
                    <h3 style={styles.sectionTitle}>🎁 What's Included</h3>
                    <div style={styles.featureGrid}>
                      {selectedPlan.whatsIncluded.map((item, idx) => (
                        <div key={idx} style={styles.featureItem}>
                          <span style={{ fontSize: "1.2rem" }}>✓</span>
                          <span style={{ color: "#1e293b" }}>{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Features */}
                  <div>
                    <h3 style={styles.sectionTitle}>✨ Features & Benefits</h3>
                    <div style={styles.featureGrid}>
                      {selectedPlan.features.map((feature, idx) => (
                        <div key={idx} style={styles.featureItem}>
                          <span style={{ fontSize: "1.2rem" }}>{feature.icon}</span>
                          <div>
                            <div style={{ fontWeight: "600", color: "#1e293b" }}>{feature.name}</div>
                            <div style={{
                              fontSize: "0.85rem",
                              color: feature.included ? "#10b981" : "#94a3b8"
                            }}>
                              {feature.included ? "✓ Included" : "✗ Not included"}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Intended Learners */}
                  <div>
                    <h3 style={styles.sectionTitle}>🎯 Intended For</h3>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                      {selectedPlan.intendedLearners.map((learner, idx) => (
                        <span
                          key={idx}
                          style={{
                            ...styles.badge,
                            background: "#ebd5b3ff",
                            color: "#ff7e5f",
                            border: "1px solid #bae6fd",
                          }}
                        >
                          {learner}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Curriculum Tab */}
              {activeTab === "curriculum" && (
                <div>
                  <h3 style={styles.sectionTitle}>📚 Course Curriculum</h3>
                  
                  {selectedPlan.courses.length > 0 ? (
                    <>
                      {/* Display each course from the API */}
                      {selectedPlan.courses.map((course, idx) => (
                        <div
                          key={course.id || idx}
                          style={{
                            ...styles.courseCard,
                            borderLeftColor: "#ff7e5f",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
                            {course.cover_img && (
                              <img 
                                src={course.cover_img} 
                                alt={course.title}
                                style={{
                                  width: "120px",
                                  height: "80px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  flexShrink: 0
                                }}
                              />
                            )}
                            <div style={{ flex: 1 }}>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                <div>
                                  <h4 style={{ fontWeight: "600", color: "#1e293b", marginBottom: "5px" }}>
                                    {course.title}
                                  </h4>
                                  <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "10px" }}>
                                    <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
                                      ⏱️ {course.duration || "Self-paced"}
                                    </span>
                                    <span style={{
                                      ...styles.badge,
                                      background: "#dbeafe",
                                      color: "#ff7e5f",
                                      fontSize: "0.75rem",
                                      padding: "4px 8px",
                                    }}>
                                      {course.level || "All Levels"}
                                    </span>
                                  </div>
                                </div>
                                <span style={{ color: "#64748b", fontSize: "0.9rem" }}>
                                  Course {idx + 1}
                                </span>
                              </div>

                              {course.description && (
                                <p style={{ color: "#64748b", marginBottom: "15px", fontSize: "0.95rem" }}>
                                  {course.description}
                                </p>
                              )}

                              {/* Learning Objectives */}
                              {course.objectives && course.objectives.length > 0 && (
                                <div style={{ marginBottom: "15px" }}>
                                  <strong style={{ color: "#475569", display: "block", marginBottom: "8px" }}>
                                    Learning Objectives:
                                  </strong>
                                  <ul style={{ margin: 0, paddingLeft: "20px", color: "#64748b" }}>
                                    {course.objectives.map((obj, objIdx) => (
                                      <li key={objIdx} style={{ marginBottom: "4px" }}>{obj}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              {/* Resources */}
                              {course.resources && course.resources.length > 0 && (
                                <div>
                                  <strong style={{ color: "#475569", display: "block", marginBottom: "8px" }}>
                                    Resources Included:
                                  </strong>
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                    {course.resources.map((resource, resIdx) => (
                                      <span
                                        key={resIdx}
                                        style={{
                                          ...styles.badge,
                                          background: "#f1f5f9",
                                          color: "#475569",
                                          border: "1px solid #e2e8f0",
                                        }}
                                      >
                                        {resource}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div style={{ 
                      textAlign: "center", 
                      padding: "40px", 
                      background: "#f8fafc", 
                      borderRadius: "12px",
                      color: "#64748b"
                    }}>
                      <p style={{ fontSize: "1.1rem", marginBottom: "10px" }}>
                        📚 No courses available yet
                      </p>
                      <p>Courses will be added to this membership soon.</p>
                    </div>
                  )}
                </div>
              )}

              {/* Instructor Tab */}
              {activeTab === "instructor" && (
                <div>
                  <div style={{ display: "flex", gap: "25px", marginBottom: "30px" }}>
                    <div style={{
                      width: "120px",
                      height: "120px",
                      borderRadius: "50%",
                      background: "linear-gradient(90deg, #ff7e5f, #8e44ad)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "2.5rem",
                      fontWeight: "700",
                      flexShrink: 0,
                    }}>
                      {selectedPlan.instructor.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div>
                      <h3 style={{ fontSize: "1.5rem", fontWeight: "700", color: "#1e293b", marginBottom: "10px" }}>
                        {selectedPlan.instructor}
                      </h3>
                      <p style={{ color: "#475569", lineHeight: "1.6", marginBottom: "20px" }}>
                        {selectedPlan.instructorBio}
                      </p>
                      <div style={{ display: "flex", gap: "25px" }}>
                        <div>
                          <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "#ff7e5f" }}>
                            {selectedPlan.rating}/5
                          </div>
                          <div style={{ fontSize: "0.9rem", color: "#64748b" }}>Instructor Rating</div>
                        </div>
                        <div>
                          <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "#8e44ad" }}>
                            {selectedPlan.students}+
                          </div>
                          <div style={{ fontSize: "0.9rem", color: "#64748b" }}>Students Taught</div>
                        </div>
                        <div>
                          <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "#ff7e5f" }}>
                            {selectedPlan.courses.length}
                          </div>
                          <div style={{ fontSize: "0.9rem", color: "#64748b" }}>Courses Created</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 style={styles.sectionTitle}>📝 Teaching Philosophy</h3>
                    <p style={{ color: "#475569", lineHeight: "1.8" }}>
                      With extensive experience in veterinary education and clinical practice,
                      {selectedPlan.instructor.split(' ')[0]} brings real-world expertise and practical
                      knowledge to every course. Committed to advancing veterinary education through
                      innovative teaching methods and hands-on learning experiences.
                    </p>
                  </div>
                </div>
              )}

              {/* Enroll Tab */}
              {activeTab === "enroll" && (
                <div>
                  {(() => {
                    // Check membership status from API
                    const membershipId = selectedPlan.apiData?.id;
                    const enrollment = membershipId ? checkUserEnrollment(membershipId) : null;
                    const isMember = membershipId ? isUserMember(membershipId) : false;
                    
                    if (isMember) {
                      // User is already a member (admin approved)
                      return (
                        <div style={{ textAlign: "center", padding: "40px" }}>
                          <div style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            background: "#d1fae5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            fontSize: "2rem",
                          }}>
                            🎉
                          </div>
                          <h3 style={{ color: "#059669", marginBottom: "10px" }}>
                            Welcome Member!
                          </h3>
                          <p style={{ color: "#64748b", marginBottom: "25px" }}>
                            You are already an active member of <strong>{selectedPlan.name}</strong>.
                            Enjoy your learning journey!
                          </p>
                          {selectedPlan.access_type !== "free" && selectedPlan.price !== "Free" && (
                            <p style={{ 
                              color: "#f59e0b", 
                              background: "#fef3c7", 
                              padding: "10px", 
                              borderRadius: "8px",
                              marginBottom: "20px" 
                            }}>
                              💰 Payment status: Approved (Payment integration coming soon)
                            </p>
                          )}
                          <button
                            onClick={() => {
                              alert("Redirecting to your membership dashboard...");
                              // In a real app, you would navigate to the member dashboard
                              setSelectedPlan(null);
                            }}
                            style={{
                              ...styles.btn,
                              padding: "16px 40px",
                              fontSize: "1.1rem",
                              background: "linear-gradient(90deg, #10b981, #34d399)",
                            }}
                          >
                            🚀 Go to Dashboard
                          </button>
                          <button
                            onClick={() => setSelectedPlan(null)}
                            style={{
                              ...styles.backBtn,
                              marginTop: "15px",
                            }}
                          >
                            ← Back to Memberships
                          </button>
                        </div>
                      );
                    } else if (enrollment) {
                      // User has applied but not yet approved
                      return renderPendingEnrollmentView();
                    } else {
                      // No enrollment yet - show enrollment form
                      return renderEnrollmentForm();
                    }
                  })()}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}